import React, { Component } from 'react';
import { Redirect, withRouter } from 'react-router-dom';
import AjaxHandler from '../../commons/ajax/AjaxHandler.js';
import Security from '../../commons/security/Security.js';
import Loading from '../ui/Loading.js';
import { injectIntl, FormattedMessage } from 'react-intl';
import crearEricConversacionesService from './ericConversacionesService.js';
import LocaleFormat from '../../commons/utils/LocaleFormat.js';
import ConfigBusiness from '../../commons/config/ConfigBusiness.js';
import swal from 'sweetalert';
import ReactMarkdown from 'react-markdown';
import VECLoader from './VECLoader.jsx';
import EricChart from './EricChart.js';
import { descargarCSV, descargarXLSX } from '../../commons/utils/tableDownload.js';
import { nombreArchivoDesdeTitulo } from '../../commons/utils/chartPng.js';

// Velocidad del efecto "letra por letra" para la respuesta del asistente.
// Más bajo = tipeo más rápido. Calibrado a algo cercano a OpenAI/Claude streaming.
var STREAM_CHAR_MS_EXPLICACION = 12;
// Delay entre el final del tipeo de la explicación y la aparición de la tabla.
var STREAM_DELAY_TABLA_MS = 200;
// Tiempo que se muestra el loader fake antes de cerrar el streaming de la tabla.
var STREAM_DELAY_LOADING_MS = 800;
// Caracteres por tick para textos largos (avanza más de a 1 si es muy largo).
var STREAM_CHARS_PER_TICK = 3;

var FRASES_LOADING = {
  es: [
    'Analizando tu consulta...',
    'Consultando los datos de tu flota...',
    'Calculando métricas...',
    'Buscando en la base de datos...',
    'Procesando resultados...',
    'Preparando la respuesta...',
    'Un momento más...',
  ],
  pt: [
    'Analisando sua consulta...',
    'Consultando os dados da frota...',
    'Calculando métricas...',
    'Buscando no banco de dados...',
    'Processando resultados...',
    'Preparando a resposta...',
    'Um momento...',
  ],
};

var SUGERENCIAS_ERIC = [
  // Operaciones diarias
  { id: 'eric.sugerencia.vehiculos_en_taller',           defaultMessage: '¿Cuántos vehículos tengo en taller?' },
  { id: 'eric.sugerencia.documentos_vencidos',           defaultMessage: '¿Tengo documentos vencidos de mi flota?' },
  { id: 'eric.sugerencia.vehiculo_mas_km',               defaultMessage: '¿Cuál es el vehículo con más kilómetros?' },
  { id: 'eric.sugerencia.vehiculos_activos',             defaultMessage: '¿Cuántos vehículos están activos hoy?' },
  { id: 'eric.sugerencia.preventivos_pendientes',        defaultMessage: '¿Qué mantenimientos preventivos están pendientes?' },
  { id: 'eric.sugerencia.vtv_vencida',                   defaultMessage: '¿Qué vehículos tienen la VTV vencida?' },
  { id: 'eric.sugerencia.patente_por_vencer',            defaultMessage: '¿Qué vehículos tienen patente por vencer?' },
  { id: 'eric.sugerencia.seguro_por_vencer',             defaultMessage: '¿Cuáles son los vehículos con seguro por vencer?' },
  { id: 'eric.sugerencia.ot_abiertas',                   defaultMessage: '¿Qué órdenes de trabajo están abiertas?' },
  { id: 'eric.sugerencia.vehiculos_ociosos',             defaultMessage: '¿Cuántos vehículos están ociosos hoy?' },
  { id: 'eric.sugerencia.proximo_service',               defaultMessage: '¿Qué vehículo está más cerca de su próximo service?' },
  // Costos y finanzas
  { id: 'eric.sugerencia.costo_por_km',                  defaultMessage: '¿Cuál es el costo por kilómetro de cada vehículo?' },
  { id: 'eric.sugerencia.gasto_correctivo_vs_preventivo',defaultMessage: '¿Cuánto se gastó en mantenimiento correctivo versus preventivo este año?' },
  { id: 'eric.sugerencia.gasto_combustible_mes',         defaultMessage: '¿Cuál fue el gasto en combustible del último mes?' },
  { id: 'eric.sugerencia.taller_mayor_facturacion',      defaultMessage: '¿Qué taller concentra mayor facturación?' },
  { id: 'eric.sugerencia.tickets_alto_costo',            defaultMessage: '¿Cuántos tickets superaron los 500000 en costo?' },
  { id: 'eric.sugerencia.deuda_infracciones',            defaultMessage: '¿Cuánto se adeuda en infracciones?' },
  { id: 'eric.sugerencia.presupuestos_pendientes',       defaultMessage: '¿Cuántos presupuestos están pendientes de aprobación y cuál es el monto total?' },
  { id: 'eric.sugerencia.evolucion_gasto_mensual',       defaultMessage: '¿Cuál fue la evolución mensual del gasto en mantenimiento?' },
  { id: 'eric.sugerencia.repuestos_vs_mano_obra',        defaultMessage: '¿Cuánto se gastó en repuestos versus mano de obra este año?' },
  // Seguridad y conductores
  { id: 'eric.sugerencia.siniestros_anio',               defaultMessage: '¿Cuántos siniestros tuve este año?' },
  { id: 'eric.sugerencia.choferes_infracciones',         defaultMessage: '¿Qué choferes tienen infracciones pendientes?' },
  { id: 'eric.sugerencia.licencias_por_vencer',          defaultMessage: '¿Qué choferes tienen la licencia por vencer?' },
  // Flota y activos
  { id: 'eric.sugerencia.distribucion_por_tipo',         defaultMessage: '¿Cuál es la distribución de vehículos por tipo?' },
  { id: 'eric.sugerencia.km_flota_mes',                  defaultMessage: '¿Cuántos kilómetros recorrió mi flota este mes?' },
  { id: 'eric.sugerencia.vehiculo_mas_reparaciones',     defaultMessage: '¿Cuál es el vehículo con más reparaciones?' },
  { id: 'eric.sugerencia.tasa_utilizacion',              defaultMessage: '¿Cuál es la tasa de utilización de la flota?' },
  { id: 'eric.sugerencia.cuotas_renting_mes',            defaultMessage: '¿Cuánto se pagó en cuotas de renting este mes?' },
];

function getRandomSugerencias(intl, n) {
  return SUGERENCIAS_ERIC
    .slice()
    .sort(function() { return Math.random() - 0.5; })
    .slice(0, n)
    .map(function(s) { return intl.formatMessage(s); });
}

var LOCALE_TO_CURRENCY = {
  'es-AR': 'ARS', 'pt-BR': 'BRL', 'en-US': 'USD',
  'es-CL': 'CLP', 'es-CO': 'COP', 'es-MX': 'MXN',
  'es-UY': 'UYU', 'es-PY': 'PYG',
};

var MONETARY_KEYWORDS = [
  'importe', 'precio', 'costo', 'monto', 'deuda',
  'repuestos', 'mano_de_obra', 'gasto', 'tarifa',
  'valor_adquisicion', 'valor_amortizacion', 'valor_poliza',
  'valor_franquicia', 'valor_contable', 'valor_cuota',
];

// Si el nombre de columna contiene alguna de estas palabras, es un conteo/cantidad
// y no debe formatearse como moneda aunque contenga una keyword monetaria.
var COUNT_KEYWORDS = ['cantidad', 'conteo', 'count'];

function getEricCurrency() {
  var locale = ConfigBusiness.get('generales.formatoRegional') || 'es-AR';
  return LOCALE_TO_CURRENCY[locale] || 'ARS';
}

function isCurrencyColumn(name) {
  var lower = name.toLowerCase();
  if (COUNT_KEYWORDS.some(function(kw) { return lower.indexOf(kw) !== -1; })) {
    return false;
  }
  return MONETARY_KEYWORDS.some(function(kw) { return lower.indexOf(kw) !== -1; });
}

// snake_case → "Snake case". Números >= 1000 (excluidos años 1900-2099) se
// formatean con separadores de miles; si el nombre de columna contiene un
// keyword monetario, el número lleva además el símbolo de moneda del cliente.
function formatHeader(col) {
  var lower = col.toLowerCase();
  var hasMoney = MONETARY_KEYWORDS.some(function(kw) { return lower.indexOf(kw) !== -1; });

  return String(col)
    .replace(/_/g, ' ')
    .replace(/^./, function(c) { return c.toUpperCase(); })
    .replace(/\b(\d+)\b/g, function(numStr) {
      var n = parseInt(numStr, 10);
      if (isNaN(n) || n < 1000 || (n >= 1900 && n <= 2099)) return numStr;
      return hasMoney
        ? LocaleFormat.formatCurrency(n, getEricCurrency())
        : LocaleFormat.formatNumber(n, 0);
    });
}

// Regexes para detectar fechas en valores (formato ISO de MySQL).
var ISO_DATETIME_REGEX = /^\d{4}-\d{2}-\d{2}[T ]\d{2}:\d{2}:\d{2}/;
var ISO_DATE_REGEX     = /^\d{4}-\d{2}-\d{2}$/;

// Inspecciona los valores de la columna y retorna { type, align, decimals }.
// type ∈ 'currency' | 'number' | 'datetime' | 'date' | 'text'
// align ∈ 'left' | 'right'
function detectColumnType(colName, valuesInColumn) {
  if (isCurrencyColumn(colName)) {
    return { type: 'currency', align: 'right', decimals: 2 };
  }
  var muestras = (valuesInColumn || []).filter(function(v) {
    return v !== null && v !== undefined && v !== '';
  });
  if (muestras.length === 0) {
    return { type: 'text', align: 'left' };
  }

  // ¿Todas numéricas?  Bool/objects no.
  var todosNumericos = muestras.every(function(v) {
    return (typeof v === 'number' || typeof v === 'string')
      && v !== ''
      && !isNaN(Number(v));
  });
  if (todosNumericos) {
    var algunoConDecimal = muestras.some(function(v) {
      var s = String(v);
      var idx = s.indexOf('.');
      return idx !== -1 && Number(s.substring(idx + 1)) > 0;
    });
    return { type: 'number', align: 'right', decimals: algunoConDecimal ? 2 : 0 };
  }

  // ¿Todas datetime ISO?
  var todosDatetime = muestras.every(function(v) {
    return typeof v === 'string' && ISO_DATETIME_REGEX.test(v);
  });
  if (todosDatetime) {
    return { type: 'datetime', align: 'left' };
  }

  // ¿Todas date ISO (sin hora)?
  var todosDate = muestras.every(function(v) {
    return typeof v === 'string' && ISO_DATE_REGEX.test(v);
  });
  if (todosDate) {
    return { type: 'date', align: 'left' };
  }

  return { type: 'text', align: 'left' };
}

function formatByType(value, colType) {
  if (value === null || value === undefined || value === '') return '—';
  if (colType.type === 'currency') {
    return LocaleFormat.formatCurrency(value, getEricCurrency());
  }
  if (colType.type === 'number') {
    return LocaleFormat.formatNumber(value, colType.decimals);
  }
  if (colType.type === 'datetime') {
    return LocaleFormat.formatDateTime(value);
  }
  if (colType.type === 'date') {
    return LocaleFormat.formatDate(value);
  }
  return String(value);
}

// ---------------------------------------------------------------------------
// Copiar respuesta al portapapeles
// ---------------------------------------------------------------------------

// Guarda compartida: ¿el mensaje tiene una tabla renderable?
// Excluye el caso sentinel `[{ resultado: 'sin_datos' }]` que el LLM devuelve
// cuando declara que no puede responder con las tablas disponibles.
function tieneTabla(mensaje) {
  if (!mensaje || !mensaje.filas || mensaje.filas.length === 0) return false;
  if (mensaje.filas.length === 1 && mensaje.filas[0]
      && mensaje.filas[0].resultado === 'sin_datos') return false;
  return true;
}

function _filasComoMarkdown(columnas, filas) {
  // Reusa el mismo análisis de tipo/alineación que la tabla visual,
  // así el copy queda WYSIWYG.
  var tipos = columnas.map(function(col) {
    var valoresCol = filas.map(function(f) { return f[col]; });
    return detectColumnType(col, valoresCol);
  });
  function escapeCell(s) {
    // Pipes y newlines romperían el markdown; los neutralizamos.
    return String(s).replace(/\|/g, '\\|').replace(/\r?\n/g, ' ');
  }
  var headers  = columnas.map(function(c) { return escapeCell(formatHeader(c)); });
  var alignRow = tipos.map(function(t) { return t.align === 'right' ? '---:' : ':---'; });
  var lineas = [
    '| ' + headers.join(' | ') + ' |',
    '| ' + alignRow.join(' | ') + ' |',
  ];
  filas.forEach(function(fila) {
    var celdas = columnas.map(function(c, j) {
      return escapeCell(formatByType(fila[c], tipos[j]));
    });
    lineas.push('| ' + celdas.join(' | ') + ' |');
  });
  return lineas.join('\n');
}

// Compone el texto plano (markdown) que va al portapapeles.
function formatMensajeParaCopia(mensaje) {
  if (!mensaje) return '';
  var partes = [];
  if (mensaje.respuesta) {
    partes.push(String(mensaje.respuesta).trim());
  }
  if ((mensaje.columnas || []).length > 0 && tieneTabla(mensaje)) {
    partes.push(_filasComoMarkdown(mensaje.columnas, mensaje.filas));
  }
  if (mensaje.totalFilas && mensaje.totalFilas > 0) {
    partes.push('_' + mensaje.totalFilas
      + (mensaje.totalFilas === 1 ? ' fila_' : ' filas_'));
  }
  return partes.join('\n\n');
}

function _escapeHtml(s) {
  return String(s)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

// Genera una tabla HTML con estilos inline para que al pegar en Gmail,
// Notion, Slack o Word se vea como tabla formateada en lugar de texto plano.
function _filasComoHtml(columnas, filas) {
  var tipos = columnas.map(function(col) {
    var vals = filas.map(function(f) { return f[col]; });
    return detectColumnType(col, vals);
  });
  var thStyle = 'border:1px solid #ccc;padding:6px 10px;background:#f0f0f0;white-space:nowrap;';
  var tdBase  = 'border:1px solid #ccc;padding:6px 10px;white-space:nowrap;';
  var html = '<table style="border-collapse:collapse;font-family:sans-serif;font-size:13px;">';
  html += '<thead><tr>';
  columnas.forEach(function(col, j) {
    var align = tipos[j].align === 'right' ? 'right' : 'left';
    html += '<th style="' + thStyle + 'text-align:' + align + ';">'
      + _escapeHtml(formatHeader(col)) + '</th>';
  });
  html += '</tr></thead><tbody>';
  filas.forEach(function(fila, i) {
    var rowBg = i % 2 === 1 ? 'background:#f9f9f9;' : '';
    html += '<tr>';
    columnas.forEach(function(col, j) {
      var align = tipos[j].align === 'right' ? 'right' : 'left';
      html += '<td style="' + tdBase + rowBg + 'text-align:' + align + ';">'
        + _escapeHtml(formatByType(fila[col], tipos[j])) + '</td>';
    });
    html += '</tr>';
  });
  html += '</tbody></table>';
  return html;
}

// Compone el HTML enriquecido del mensaje para el portapapeles.
function formatMensajeParaCopiaHtml(mensaje) {
  if (!mensaje) return '';
  var partes = [];
  if (mensaje.respuesta) {
    partes.push('<p style="font-family:sans-serif;font-size:13px;margin:0 0 8px 0;">'
      + _escapeHtml(String(mensaje.respuesta).trim()) + '</p>');
  }
  if ((mensaje.columnas || []).length > 0 && tieneTabla(mensaje)) {
    partes.push(_filasComoHtml(mensaje.columnas, mensaje.filas));
  }
  if (mensaje.totalFilas && mensaje.totalFilas > 0) {
    partes.push('<p style="font-family:sans-serif;font-size:12px;color:#666;margin:4px 0 0 0;"><em>'
      + _escapeHtml(String(mensaje.totalFilas))
      + (mensaje.totalFilas === 1 ? ' fila' : ' filas') + '</em></p>');
  }
  return partes.join('');
}

// Copia al portapapeles usando ClipboardItem (HTML + texto) cuando está disponible,
// con fallback a writeText y luego a textarea+execCommand para HTTP no-localhost.
function copiarAlPortapapeles(texto, html) {
  if (html && navigator.clipboard && window.ClipboardItem) {
    try {
      var htmlBlob  = new Blob([html],  { type: 'text/html' });
      var textBlob  = new Blob([texto], { type: 'text/plain' });
      var item = new window.ClipboardItem({ 'text/html': htmlBlob, 'text/plain': textBlob });
      return navigator.clipboard.write([item])
        .then(function() { return true; })
        .catch(function() {
          return navigator.clipboard.writeText(texto)
            .then(function() { return true; })
            .catch(function() { return _copiarFallback(texto); });
        });
    } catch (e) {
      // ClipboardItem no soportado; caer al path plain-text
    }
  }
  if (navigator.clipboard && navigator.clipboard.writeText) {
    return navigator.clipboard.writeText(texto)
      .then(function() { return true; })
      .catch(function() { return _copiarFallback(texto); });
  }
  return Promise.resolve(_copiarFallback(texto));
}

function _copiarFallback(texto) {
  try {
    var ta = document.createElement('textarea');
    ta.value = texto;
    ta.setAttribute('readonly', '');
    ta.style.position = 'fixed';
    ta.style.top = '0';
    ta.style.left = '0';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.select();
    var ok = document.execCommand('copy');
    document.body.removeChild(ta);
    return ok;
  } catch (e) {
    return false;
  }
}

// Extrae el id de conversación desde un pathname tipo "/eric/conversaciones/42".
// Devuelve null si el pathname no matchea o el id no es numérico.
function getConversacionIdFromPathname(pathname) {
  if (!pathname) return null;
  var m = pathname.match(/\/eric\/conversaciones\/(\d+)\/?$/);
  if (!m) return null;
  var id = parseInt(m[1], 10);
  return isNaN(id) ? null : id;
}

/**
 * EricAnalyst — pantalla de chatbot para consultas en lenguaje natural.
 *
 * Llama a POST /api/eric/consultar y muestra los resultados de forma
 * conversacional. Cada intercambio queda en el historial de la sesión.
 * Requiere permiso ERIC_CONSULTAR.
 */
// Exportado nombrado para tests unitarios. El default sigue siendo la versión envuelta en injectIntl.
export class EricAnalyst extends Component {
  constructor(props) {
    super(props);

    this.ajaxHandler = new AjaxHandler();
    this._conversacionesService = null; // se inicializa en componentDidMount tras subscribe
    // Id de la conversación cuya carga está en vuelo. Se usa para descartar
    // respuestas viejas (race condition al cambiar de conversación rápido) y
    // para evitar que componentDidUpdate vuelva a disparar la misma carga.
    this._loadingConversacionId = null;
    // Flag + timeout id para el feedback "Copiado" del botón copiar.
    // Necesarios para no llamar setState sobre una instancia desmontada.
    this._isMounted = false;
    this._copiadoTimeoutId = null;
    this._mensajesEndRef = React.createRef();
    this._consultaRef = React.createRef();
    this._conversacionRef = React.createRef();
    this._preguntaActualRef = React.createRef();
    this._sidebarBodyRef = React.createRef();
    // Refs a las instancias de EricChart por índice de mensaje, para disparar la
    // descarga PNG del gráfico desde la fila de acciones (junto a like/dislike).
    this._chartRefs = {};
    // Al enviar una pregunta anclamos el scroll a esa pregunta (no seguimos el
    // final mientras se tipea la respuesta). Lo marca handleSubmit y lo consume
    // componentDidUpdate una vez renderizado el turno nuevo.
    this._anclarPreguntaPendiente = false;
    // Timers del efecto streaming (tipeo letra por letra). Se cancelan en
    // componentWillUnmount y al iniciar un nuevo streaming.
    this._streamingInterval = null;
    this._streamingTimeout = null;
    this._copiadoTablaTimeoutId = null;
    this._loadingPhraseTimer = null;

    // Sidebar: siempre cerrado por defecto, el usuario lo abre cuando lo necesita
    var sidebarAbiertoPorDefecto = false;

    this.state = {
      redirectTo: null,
      mensajes: [],
      cargando: false,
      fraseLoadingIdx: 0,
      copiadoEnIndex: null,
      // Índices de mensajes cuya fecha se muestra como "hace X" (toggle al clickear).
      fechaRelativaIndices: {},
      copiadoTablaEnIndex: null,
      tieneTexto: false,
      sugerencias: getRandomSugerencias(this.props.intl, 4),
      // Estado del efecto streaming. mensajeIdx es el índice del mensaje
      // que se está animando dentro de state.mensajes. phase recorre:
      // 'explicacion' -> 'tabla' -> 'loading' -> done
      streaming: {
        active: false,
        phase: null,
        mensajeIdx: -1,
        textLen: 0,
      },
      feedbackModal: {
        open: false,
        index: -1,
        mensaje: null,
        categoria: '',
        comentario: '',
      },
      // Conversaciones persistentes (ERIC 2.0)
      conversacionActiva: null,
      conversaciones: [],
      cargandoConversaciones: false,
      cargandoConversacion: false,
      conversacionCerrada: false,
      sidebarAbierto: sidebarAbiertoPorDefecto,
      menuHeaderAbierto: false,
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.handleLimpiarHistorial = this.handleLimpiarHistorial.bind(this);
    this.handleNuevaConversacion = this.handleNuevaConversacion.bind(this);
    this.handleAbrirConversacion = this.handleAbrirConversacion.bind(this);
    this.handleEliminarConversacion = this.handleEliminarConversacion.bind(this);
    this.handleBorrarTodas = this.handleBorrarTodas.bind(this);
    this.handleCargarMasConversaciones = this.handleCargarMasConversaciones.bind(this);
    this.handleSidebarScroll = this.handleSidebarScroll.bind(this);
    this.handleToggleSidebar = this.handleToggleSidebar.bind(this);
    this.handleCopiarMensaje = this.handleCopiarMensaje.bind(this);
    this.handleEnviarFeedback = this.handleEnviarFeedback.bind(this);
    this.handleAbrirModalFeedback = this.handleAbrirModalFeedback.bind(this);
    this.handleCerrarModalFeedback = this.handleCerrarModalFeedback.bind(this);
    this.handleSubmitFeedbackNegativo = this.handleSubmitFeedbackNegativo.bind(this);
    this.handleTextareaChange = this.handleTextareaChange.bind(this);
    this.handleSugerencia = this.handleSugerencia.bind(this);
  }

  componentDidMount() {
    this._isMounted = true;
    document.body.classList.add('eric-analyst-active');
    window.scrollTo(0, 0);
    this._handleResize = function() {
      if (window.innerWidth < 900 && this.state.sidebarAbierto) {
        this.setState({ sidebarAbierto: false });
      }
    }.bind(this);
    window.addEventListener('resize', this._handleResize);
    if (!Security.hasPermission('ERIC_CONSULTAR')) {
      this.setState({ redirectTo: '/error' });
      return;
    }
    this.ajaxHandler.subscribe(this);
    // Inicializar el servicio de conversaciones aquí, después del subscribe,
    // para que use el AjaxHandler ya suscripto.
    this._conversacionesService = crearEricConversacionesService(this.ajaxHandler);
    // Cargar listado de conversaciones en background (no bloquea el render del chat).
    this._cargarConversaciones(1);
    this._scrollAlFinal();
    var params = new URLSearchParams(window.location.search);
    var preguntaInicial = params.get('q');
    if (preguntaInicial && this._consultaRef && this._consultaRef.current) {
      window.history.replaceState({}, '', window.location.pathname);
      this._consultaRef.current.value = preguntaInicial;
      this.setState({ tieneTexto: true }, function() { this.handleSubmit(); }.bind(this));
    } else {
      // Si entramos directo a /eric/conversaciones/:id, cargar esa conversación.
      var urlConversacionId = getConversacionIdFromPathname(
        this.props.location && this.props.location.pathname
          ? this.props.location.pathname
          : (typeof window !== 'undefined' ? window.location.pathname : '')
      );
      if (urlConversacionId !== null) {
        this._loadConversacion(urlConversacionId);
      } else if (this._consultaRef && this._consultaRef.current) {
        this._consultaRef.current.focus();
      }
    }
  }

  _cargarConversaciones(pagina) {
    if (!this._isMounted || !this._conversacionesService) return;
    var self = this;
    this.setState({ cargandoConversaciones: true });
    this._conversacionesService.listar(pagina, 20).then(function(resultado) {
      if (!self._isMounted) return;
      self.setState(function(prev) {
        var listaActual = pagina === 1 ? [] : (prev.conversaciones || []);
        return {
          conversaciones: listaActual.concat(resultado.conversaciones),
          _conversacionesPaginacion: resultado.paginacion,
          cargandoConversaciones: false,
        };
      });
    });
  }

  _scrollAlFinal() {
    if (this._mensajesEndRef && this._mensajesEndRef.current) {
      this._mensajesEndRef.current.scrollIntoView({ behavior: 'instant' });
    }
  }

  // Ancla el scroll de la conversación a la última pregunta del usuario, dejando
  // su tope alineado con el tope del contenedor. Así quedan visibles la pregunta
  // y el comienzo de la respuesta, sin seguir el final mientras la respuesta crece.
  _scrollAPreguntaActual() {
    var cont = this._conversacionRef && this._conversacionRef.current;
    var preg = this._preguntaActualRef && this._preguntaActualRef.current;
    if (!cont || !preg) {
      this._scrollAlFinal();
      return;
    }
    var contRect = cont.getBoundingClientRect();
    var pregRect = preg.getBoundingClientRect();
    // -8px para compensar el padding superior del contenedor (.eric-conversacion).
    cont.scrollTop += (pregRect.top - contRect.top) - 8;
  }

  componentWillUnmount() {
    this._isMounted = false;
    window.removeEventListener('resize', this._handleResize);
    if (this._copiadoTimeoutId) {
      clearTimeout(this._copiadoTimeoutId);
      this._copiadoTimeoutId = null;
    }
    if (this._copiadoTablaTimeoutId) {
      clearTimeout(this._copiadoTablaTimeoutId);
      this._copiadoTablaTimeoutId = null;
    }
    this._cancelStreaming();
    clearInterval(this._loadingPhraseTimer);
    this.ajaxHandler.unsubscribe();
    document.body.classList.remove('eric-analyst-active');
  }

  componentDidUpdate(prevProps, prevState) {
    // Sync conversación activa con la URL (navegación back/forward del browser,
    // o entrar a /eric desde otra parte de la app). Cuando los handlers ya
    // actualizaron state.conversacionActiva o ya hay un load en vuelo, hacemos
    // no-op para no disparar dobles fetch.
    var prevPath = prevProps.location ? prevProps.location.pathname : '';
    var currPath = this.props.location ? this.props.location.pathname : '';
    if (prevPath !== currPath) {
      var prevUrlConvId = getConversacionIdFromPathname(prevPath);
      var currUrlConvId = getConversacionIdFromPathname(currPath);
      if (currUrlConvId !== prevUrlConvId) {
        if (currUrlConvId === null) {
          if (this.state.conversacionActiva !== null) {
            this._resetConversacionState();
          }
        } else if (
          currUrlConvId !== this.state.conversacionActiva
          && this._loadingConversacionId !== currUrlConvId
        ) {
          this._loadConversacion(currUrlConvId);
        }
      }
    }

    // Si el header de ERIC navegó a /eric?q=... estando ya en la página,
    // componentDidMount no se re-ejecuta. Detectamos el cambio de search aquí.
    var prevSearch = prevProps.location ? prevProps.location.search : '';
    var currSearch = this.props.location ? this.props.location.search : '';
    if (currSearch !== prevSearch && currSearch) {
      var params = new URLSearchParams(currSearch);
      var pregunta = params.get('q');
      if (pregunta && !this.state.cargando && !this.state.streaming.active) {
        window.history.replaceState({}, '', window.location.pathname);
        if (this._consultaRef && this._consultaRef.current) {
          this._consultaRef.current.value = pregunta;
          this.setState({ tieneTexto: true }, function() { this.handleSubmit(); }.bind(this));
        }
      }
    }

    if (prevState.mensajes.length > 0 && this.state.mensajes.length === 0 && !this.state.cargando) {
      if (this._consultaRef && this._consultaRef.current) {
        this._consultaRef.current.focus();
      }
    }
    var wasLoading = prevState.cargando;
    var isLoading  = this.state.cargando;
    if (!wasLoading && isLoading) {
      var self = this;
      this._loadingPhraseTimer = setInterval(function() {
        self.setState(function(s) { return { fraseLoadingIdx: s.fraseLoadingIdx + 1 }; });
      }, 2500);
    }
    if (wasLoading && !isLoading) {
      clearInterval(this._loadingPhraseTimer);
      this._loadingPhraseTimer = null;
      this.setState({ fraseLoadingIdx: 0 });
    }

    if (prevState.mensajes === this.state.mensajes
        && prevState.cargando === this.state.cargando
        && prevState.streaming === this.state.streaming) return;

    // Al enviar una pregunta nueva, anclamos el scroll a esa pregunta (queda su
    // tope arriba y se ve el comienzo de la respuesta). Durante el resto de los
    // updates (tipeo del streaming, loader) NO auto-scrolleamos, así el ancla se
    // mantiene en la pregunta en vez de seguir el final de la respuesta.
    if (this._anclarPreguntaPendiente) {
      this._anclarPreguntaPendiente = false;
      this._scrollAPreguntaActual();
    }
  }

  handleKeyDown(event) {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      this.handleSubmit();
    }
  }

  // handleLimpiarHistorial: limpia el panel actual sin tocar la conversación en DB.
  // Equivalente a "Nueva conversación" (resetea mensajes y conversacionActiva).
  // Se mantiene por compatibilidad con tests existentes pero ahora delega a handleNuevaConversacion.
  handleLimpiarHistorial() {
    this.handleNuevaConversacion();
  }

  // Resetea el panel de chat (mensajes vacíos, sin conversación activa).
  // El botón "+ Nueva conversación" del sidebar llama a este método.
  handleNuevaConversacion() {
    this._resetConversacionState();
    this._pushUrlIfDifferent('/eric');
    if (this._consultaRef && this._consultaRef.current) {
      this._consultaRef.current.focus();
    }
  }

  // Resetea state al "chat vacío" sin tocar la URL. Usado por handleNuevaConversacion
  // y por componentDidUpdate cuando la URL cambia externamente a /eric.
  _resetConversacionState() {
    this._loadingConversacionId = null;
    this.setState({
      mensajes: [],
      conversacionActiva: null,
      conversacionCerrada: false,
      sugerencias: getRandomSugerencias(this.props.intl, 4),
    });
  }

  // Empuja una URL en el history si difiere de la actual. No-op si no hay router
  // (tests, instanciación directa).
  _pushUrlIfDifferent(target) {
    if (!this.props.history || !this.props.location) return;
    var current = this.props.location.pathname + (this.props.location.search || '');
    if (current === target) return;
    this.props.history.push(target);
  }

  // Abre una conversación del sidebar: actualiza la URL y carga sus mensajes
  // desde el backend. Cancela streaming si está activo.
  handleAbrirConversacion(id) {
    if (id == null) return;
    if (id === this.state.conversacionActiva) return;
    this._pushUrlIfDifferent('/eric/conversaciones/' + id);
    this._loadConversacion(id);
  }

  // Carga una conversación desde el backend y la muestra en el panel.
  // Usa _loadingConversacionId para descartar respuestas viejas si el usuario
  // cambia de conversación antes de que termine el fetch.
  _loadConversacion(id) {
    if (!this._conversacionesService) return;
    if (this.state.streaming.active) {
      this._finalizarStreaming();
    }
    this._loadingConversacionId = id;
    var self = this;
    this.setState({ cargandoConversacion: true, mensajes: [], conversacionActiva: null });
    this._conversacionesService
      .obtener(id)
      .then(function(conv) {
        if (!self._isMounted) return;
        if (self._loadingConversacionId !== id) return;
        self._loadingConversacionId = null;
        self.setState({
          mensajes: conv.mensajes,
          conversacionActiva: conv.id,
          conversacionCerrada: conv.offerEstado === 'ticket_creado',
          cargandoConversacion: false,
        }, function() {
          self._scrollAlFinal();
        });
      })
      .catch(function() {
        if (!self._isMounted) return;
        if (self._loadingConversacionId === id) {
          self._loadingConversacionId = null;
        }
        self.setState({ cargandoConversacion: false });
        swal({
          title: self.props.intl.formatMessage({
            id: 'eric.error_cargar_conversacion',
            defaultMessage: 'No se pudo cargar la conversación.',
          }),
          icon: 'error',
        });
      });
  }

  // Elimina una conversación del sidebar con confirmación.
  // Si era la activa, vacía el panel de chat.
  handleEliminarConversacion(id) {
    if (!this._conversacionesService) return;
    var self = this;
    swal({
      title: this.props.intl.formatMessage({
        id: 'eric.confirmar_eliminar_titulo',
        defaultMessage: 'Eliminar conversación',
      }),
      text: this.props.intl.formatMessage({
        id: 'eric.confirmar_eliminar_texto',
        defaultMessage: '¿Borrar esta conversación? Esta acción no se puede deshacer.',
      }),
      icon: 'warning',
      buttons: [
        this.props.intl.formatMessage({
          id: 'eric.confirmar_eliminar_cancelar',
          defaultMessage: 'Cancelar',
        }),
        this.props.intl.formatMessage({
          id: 'eric.confirmar_eliminar_confirmar',
          defaultMessage: 'Eliminar',
        }),
      ],
      dangerMode: true,
    }).then(function(confirmado) {
      if (!confirmado) return;
      self._conversacionesService
        .eliminar(id)
        .then(function() {
          if (!self._isMounted) return;
          var eraActivaSnap = self.state.conversacionActiva === id;
          self.setState(function(prev) {
            var nuevasConversaciones = prev.conversaciones.filter(function(c) {
              return c.id !== id;
            });
            var eraActiva = prev.conversacionActiva === id;
            return {
              conversaciones: nuevasConversaciones,
              mensajes: eraActiva ? [] : prev.mensajes,
              conversacionActiva: eraActiva ? null : prev.conversacionActiva,
            };
          });
          if (eraActivaSnap) {
            self._pushUrlIfDifferent('/eric');
          }
        })
        .catch(function() {
          if (!self._isMounted) return;
          swal({
            title: self.props.intl.formatMessage({
              id: 'eric.error_borrar',
              defaultMessage: 'No se pudo eliminar la conversación. Intentá de nuevo.',
            }),
            icon: 'error',
          });
        });
    });
  }

  handleBorrarTodas() {
    if (!this._conversacionesService) return;
    var self = this;
    this.setState({ menuHeaderAbierto: false });
    swal({
      title: this.props.intl.formatMessage({
        id: 'eric.confirmar_borrar_todas_titulo',
        defaultMessage: '¿Borrar todas las conversaciones?',
      }),
      text: this.props.intl.formatMessage({
        id: 'eric.confirmar_borrar_todas_texto',
        defaultMessage: 'Esta acción no se puede deshacer.',
      }),
      icon: 'warning',
      buttons: [
        this.props.intl.formatMessage({
          id: 'eric.confirmar_eliminar_cancelar',
          defaultMessage: 'Cancelar',
        }),
        this.props.intl.formatMessage({
          id: 'eric.confirmar_borrar_todas_confirmar',
          defaultMessage: 'Borrar todo',
        }),
      ],
      dangerMode: true,
    }).then(function(confirmado) {
      if (!confirmado) return;
      self._conversacionesService
        .eliminarTodas()
        .then(function() {
          if (!self._isMounted) return;
          self.setState({
            conversaciones: [],
            conversacionActiva: null,
            mensajes: [],
          });
          self._pushUrlIfDifferent('/eric');
        })
        .catch(function() {
          if (!self._isMounted) return;
          swal({
            title: self.props.intl.formatMessage({
              id: 'eric.error_borrar',
              defaultMessage: 'No se pudo eliminar la conversación. Intentá de nuevo.',
            }),
            icon: 'error',
          });
        });
    });
  }

  handleSidebarScroll(e) {
    var el = e.target;
    if (!el || this.state.cargandoConversaciones) return;
    var paginacion = this.state._conversacionesPaginacion;
    if (!paginacion || this.state.conversaciones.length >= paginacion.total) return;
    if (el.scrollTop + el.clientHeight >= el.scrollHeight - 80) {
      var paginaActual = paginacion.pagina || 1;
      this._cargarConversaciones(paginaActual + 1);
    }
  }

  // Mantenemos el método por compatibilidad pero ya no se usa en el sidebar.
  handleCargarMasConversaciones() {
    var paginacion = this.state._conversacionesPaginacion;
    if (!paginacion) return;
    var paginaActual = paginacion.pagina || 1;
    this._cargarConversaciones(paginaActual + 1);
  }

  // Toggle del sidebar en mobile.
  handleToggleSidebar() {
    this.setState(function(prev) {
      return { sidebarAbierto: !prev.sidebarAbierto };
    });
  }

  // Copia el mensaje (explicación + tabla en markdown) al portapapeles
  // y muestra el feedback visual "Copiado" durante 1.5s en ese mensaje.
  handleCopiarMensaje(index, mensaje) {
    var self = this;
    var texto = formatMensajeParaCopia(mensaje);
    if (!texto) return;
    var html = formatMensajeParaCopiaHtml(mensaje);
    copiarAlPortapapeles(texto, html).then(function(ok) {
      if (!ok || !self._isMounted) return;
      // Si el usuario ya tenía un check pendiente en otro mensaje, lo resetea.
      if (self._copiadoTimeoutId) {
        clearTimeout(self._copiadoTimeoutId);
      }
      self.setState({ copiadoEnIndex: index });
      self._copiadoTimeoutId = setTimeout(function() {
        self._copiadoTimeoutId = null;
        if (self._isMounted) {
          self.setState({ copiadoEnIndex: null });
        }
      }, 1500);
    });
  }

  handleCopiarTabla(index, mensaje) {
    var self = this;
    if (!mensaje.columnas || mensaje.columnas.length === 0) return;
    var filas = mensaje.filas || [];

    var lineas = [mensaje.columnas.join('\t')];
    filas.forEach(function(fila) {
      lineas.push(mensaje.columnas.map(function(col) {
        var v = fila[col];
        return (v == null) ? '' : String(v);
      }).join('\t'));
    });
    var textoPlano = lineas.join('\n');

    var htmlHead = '<tr>' + mensaje.columnas.map(function(c) {
      return '<th>' + c + '</th>';
    }).join('') + '</tr>';
    var htmlRows = filas.map(function(fila) {
      return '<tr>' + mensaje.columnas.map(function(col) {
        var v = fila[col];
        return '<td>' + (v == null ? '' : v) + '</td>';
      }).join('') + '</tr>';
    }).join('');
    var htmlTabla = '<table><thead>' + htmlHead + '</thead><tbody>' + htmlRows + '</tbody></table>';

    copiarAlPortapapeles(textoPlano, htmlTabla).then(function(ok) {
      if (!ok || !self._isMounted) return;
      if (self._copiadoTablaTimeoutId) clearTimeout(self._copiadoTablaTimeoutId);
      self.setState({ copiadoTablaEnIndex: index });
      self._copiadoTablaTimeoutId = setTimeout(function() {
        self._copiadoTablaTimeoutId = null;
        if (self._isMounted) self.setState({ copiadoTablaEnIndex: null });
      }, 1500);
    });
  }

  // Toggle de thumbs up/down sobre una respuesta del asistente.
  // - Click en el thumb activo  → toggle off (opinion: null) + log en backend.
  // - Click en el thumb opuesto → cambia opinion + log en backend.
  // - Click sin opinion previa  → setea opinion + log en backend.
  // Si la nueva opinión coincide con la actual, no hacemos nada (idempotencia
  // local) — el backend igual sigue siendo source of truth si el log se pierde.
  handleAbrirModalFeedback(index, mensaje) {
    this.setState({
      feedbackModal: { open: true, index: index, mensaje: mensaje, categoria: '', comentario: '' },
    });
  }

  handleCerrarModalFeedback() {
    this.setState({
      feedbackModal: { open: false, index: -1, mensaje: null, categoria: '', comentario: '' },
    });
  }

  handleSubmitFeedbackNegativo() {
    var fm = this.state.feedbackModal;
    if (!fm.mensaje) return;
    this.handleCerrarModalFeedback();
    this._enviarFeedbackAlBackend(fm.index, fm.mensaje, 'thumbs_down', fm.categoria, fm.comentario);
  }

  handleEnviarFeedback(index, mensaje, opinionNueva) {
    if (!mensaje || !mensaje.id) return;
    var actual = mensaje.opinion || null;
    // Toggle off: si el usuario clickea el mismo thumb que ya tenía activo,
    // se interpreta como retirar el voto previo.
    var siguiente = (actual === opinionNueva) ? null : opinionNueva;
    if (siguiente === actual) return;

    // thumbs_down nuevo → abrir modal para categoría y comentario.
    if (siguiente === 'thumbs_down') {
      this.handleAbrirModalFeedback(index, mensaje);
      return;
    }

    this._enviarFeedbackAlBackend(index, mensaje, siguiente, null, null);
  }

  _enviarFeedbackAlBackend(index, mensaje, siguiente, categoria, comentario) {
    var actual = mensaje.opinion || null;
    var self = this;

    // Optimistic update local: el voto se siente instantáneo.
    this._actualizarMensajeEnState(index, { opinion: siguiente });

    var body = {
      mensaje_id: mensaje.id,
      opinion: siguiente,
    };
    if (categoria) {
      body.categoria = categoria;
    }
    if (comentario) {
      body.comentario = comentario;
    }

    this.ajaxHandler
      .fetch('/eric/feedback', {
        method: 'POST',
        body: JSON.stringify(body),
        silent: true,
      })
      .then(function(response) {
        if (response && response.status >= 400) {
          self._actualizarMensajeEnState(index, { opinion: actual });
        }
      })
      .catch(function() {
        self._actualizarMensajeEnState(index, { opinion: actual });
      });
  }

  // Actualiza un turno dentro de state.mensajes fusionando los campos de `partial`.
  _actualizarMensajeEnState(index, partial) {
    this.setState(function(prev) {
      var mensajes = prev.mensajes;
      if (index < 0 || index >= mensajes.length) return null;
      var nuevo = mensajes.slice();
      nuevo[index] = Object.assign({}, mensajes[index], partial);
      return { mensajes: nuevo };
    });
  }

  handleTextareaChange(e) {
    var tieneTexto = e.target.value.trim().length > 0;
    if (tieneTexto !== this.state.tieneTexto) {
      this.setState({ tieneTexto: tieneTexto });
    }
  }

  handleSugerencia(texto) {
    if (this._consultaRef.current) {
      this._consultaRef.current.value = texto;
    }
    this.handleSubmit();
  }

  handleSubmit() {
    var consulta = this._consultaRef.current ? this._consultaRef.current.value.trim() : '';
    if (!consulta || this.state.cargando) {
      return;
    }
    // Si se envía durante el streaming, cancelarlo: la respuesta anterior
    // se muestra completa de inmediato y se libera el input para la nueva consulta.
    if (this.state.streaming.active) {
      this._finalizarStreaming();
    }
    if (this._consultaRef.current) {
      this._consultaRef.current.value = '';
    }

    // Cada turno es UNA fila del estado: pregunta + respuesta + metadata.
    // Pusheamos el turno con `respuesta: null` (pendiente) y luego lo actualizamos
    // por índice cuando llega el response del backend.
    var turnoPendiente = {
      id: null,
      modo: null,
      pregunta: consulta,
      respuesta: null,
      columnas: [],
      filas: [],
      totalFilas: 0,
      advertencia: null,
      chartSpec: null,
      metodologia: null,
      opinion: null,
      error: null,
      fechaEnvio: new Date().toISOString(),
    };

    // Índice donde el turno pendiente quedará tras el concat: es el length
    // ACTUAL (antes del setState), porque setState es async en producción y
    // leer `this.state.mensajes.length - 1` después devuelve el valor viejo.
    var turnoIdx = this.state.mensajes.length;

    // Anclar el scroll a esta pregunta una vez renderizado el turno nuevo.
    this._anclarPreguntaPendiente = true;
    this.setState(function(prevState) {
      return {
        mensajes: prevState.mensajes.concat([turnoPendiente]),
        cargando: true,
        tieneTexto: false,
      };
    });

    var userLocale = localStorage.getItem('userLocale');
    var body = {
      consulta: consulta,
    };
    if (userLocale && userLocale !== '') {
      body.userLocale = userLocale;
    }
    // ERIC 2.0: si hay una conversación activa, enviar conversacion_id para
    // continuar el hilo en lugar de crear uno nuevo.
    if (this.state.conversacionActiva !== null) {
      body.conversacion_id = this.state.conversacionActiva;
    }

    var self = this;
    var conversacionActivaAlEnviar = this.state.conversacionActiva;

    function limpiarCargando() {
      self.setState({ cargando: false });
    }

    this.ajaxHandler
      .fetch('/eric/consultar', {
        method: 'POST',
        body: JSON.stringify(body),
        silent: true,
      })
      .then(function(response) {
        if (response.status === 200) {
          return response.json().then(function(data) {
            var respuesta = data && data.data ? data.data : {};
            var modo = respuesta.modo ? respuesta.modo : 'analyst';
            // assistant y rechazado comparten shape: texto plano en `respuesta`,
            // sin tabla, sin SQL. analyst trae columnas/filas/explicacion.
            var modoTextoPlano = (modo === 'assistant' || modo === 'rechazado');
            var textoAsistente = modoTextoPlano && respuesta.respuesta
              ? respuesta.respuesta
              : (respuesta.explicacion ? respuesta.explicacion : null);
            var actualizacionTurno = {
              id: respuesta.mensaje_id != null ? respuesta.mensaje_id : null,
              modo: modo,
              respuesta: textoAsistente,
              columnas: modoTextoPlano ? [] : (respuesta.columnas ? respuesta.columnas : []),
              filas: modoTextoPlano ? [] : (respuesta.filas ? respuesta.filas : []),
              totalFilas: modoTextoPlano ? 0 : (respuesta.total_filas ? respuesta.total_filas : 0),
              advertencia: modoTextoPlano ? null : (respuesta.advertencia ? respuesta.advertencia : null),
              chartSpec: modoTextoPlano ? null : (respuesta.chart_spec ? respuesta.chart_spec : null),
              metodologia: modoTextoPlano ? null : (respuesta.metodologia ? respuesta.metodologia : null),
            };

            var conversacionIdRespuesta = respuesta.conversacion_id ? respuesta.conversacion_id : null;
            self.setState(function(prev) {
              var nuevosMensajes = prev.mensajes.slice();
              if (turnoIdx < nuevosMensajes.length) {
                nuevosMensajes[turnoIdx] = Object.assign({}, nuevosMensajes[turnoIdx], actualizacionTurno);
              }
              var nuevoConversacionActiva = prev.conversacionActiva;
              var nuevasConversaciones = prev.conversaciones ? prev.conversaciones.slice() : [];

              if (conversacionActivaAlEnviar === null && conversacionIdRespuesta) {
                nuevoConversacionActiva = conversacionIdRespuesta;
                var nuevaEnSidebar = {
                  id: conversacionIdRespuesta,
                  titulo: consulta.length > 60 ? consulta.substring(0, 60) + '...' : consulta,
                  cantidad_mensajes: 1,
                  updated_at: new Date().toISOString(),
                };
                nuevasConversaciones = [nuevaEnSidebar].concat(
                  nuevasConversaciones.filter(function(c) {
                    return c.id !== conversacionIdRespuesta;
                  })
                );
              } else if (conversacionActivaAlEnviar !== null) {
                nuevasConversaciones = nuevasConversaciones.map(function(c) {
                  if (c.id !== conversacionActivaAlEnviar) return c;
                  return Object.assign({}, c, {
                    cantidad_mensajes: (c.cantidad_mensajes || 0) + 1,
                    updated_at: new Date().toISOString(),
                  });
                });
              }

              return {
                mensajes: nuevosMensajes,
                conversacionActiva: nuevoConversacionActiva,
                conversaciones: nuevasConversaciones,
                conversacionCerrada: prev.conversacionCerrada || (respuesta.offer_estado === 'ticket_creado'),
              };
            });

            // Si la respuesta creó una conversación nueva, reflejarla en la URL
            // para que el back/forward del browser y los reloads funcionen.
            if (conversacionActivaAlEnviar === null && conversacionIdRespuesta) {
              self._pushUrlIfDifferent('/eric/conversaciones/' + conversacionIdRespuesta);
            }

            limpiarCargando();
            // Arrancamos el efecto streaming sobre el turno recién actualizado.
            // El turno ya tiene la respuesta cargada en state; tomamos el mensaje
            // completo del state actualizado para alimentar la animación.
            var mensajeRecien = Object.assign({}, turnoPendiente, actualizacionTurno);
            self._startStreamingForMensaje(turnoIdx, mensajeRecien);
          });
        }
        if (response.status === 400) {
          return response.json().then(function(data) {
            var detalle =
              data && data.detalle && data.detalle.length > 0
                ? data.detalle[0]
                : self.props.intl.formatMessage({
                    id: 'eric.error_generico',
                    defaultMessage: 'Ocurrió un error al procesar la consulta.',
                  });
            self._actualizarMensajeEnState(turnoIdx, { error: detalle });
            limpiarCargando();
          });
        }
        // Branch defensivo. Con silent:true, AjaxHandler rechaza para status >= 401,
        // así que el flujo cae en .catch(). Si en el futuro algún status no-error
        // resuelve acá, mostramos un mensaje inline.
        self._actualizarMensajeEnState(turnoIdx, {
          error: self.props.intl.formatMessage({
            id: 'eric.error_generico',
            defaultMessage: 'Ocurrió un error al procesar la consulta.',
          }),
        });
        limpiarCargando();
        return null;
      })
      .catch(function() {
        self._actualizarMensajeEnState(turnoIdx, {
          error: self.props.intl.formatMessage({
            id: 'eric.error_conexion',
            defaultMessage: 'No se pudo conectar con el servidor. Intentá de nuevo.',
          }),
        });
        limpiarCargando();
      });
  }

  // ===== Efecto streaming (tipeo letra por letra) =====

  _cancelStreaming() {
    if (this._streamingInterval) {
      clearInterval(this._streamingInterval);
      this._streamingInterval = null;
    }
    if (this._streamingTimeout) {
      clearTimeout(this._streamingTimeout);
      this._streamingTimeout = null;
    }
  }

  _setStreamingPhase(phase) {
    if (!this._isMounted) return;
    this.setState(function(prev) {
      if (!prev.streaming.active) return null;
      var next = Object.assign({}, prev.streaming, { phase: phase });
      return { streaming: next };
    });
  }

  _finalizarStreaming() {
    if (!this._isMounted) return;
    this._cancelStreaming();
    this.setState({
      streaming: { active: false, phase: null, mensajeIdx: -1, textLen: 0 },
    });
  }

  // Tipea texto en setState, avanza STREAM_CHARS_PER_TICK por tick. Cuando
  // termina llama a onDone(). El campo del state se elige por `field`
  // (actualmente solo 'textLen' para la explicación).
  _tickTexto(text, intervalMs, field, onDone) {
    var self = this;
    if (!text || text.length === 0) {
      onDone();
      return;
    }
    this._streamingInterval = setInterval(function() {
      if (!self._isMounted) {
        self._cancelStreaming();
        return;
      }
      var current = (self.state.streaming && self.state.streaming[field]) || 0;
      var charsThisTick = 1 + Math.floor(Math.random() * STREAM_CHARS_PER_TICK * 2);
      var nextLen = Math.min(current + charsThisTick, text.length);
      self.setState(function(prev) {
        if (!prev.streaming.active) return null;
        var nextStreaming = Object.assign({}, prev.streaming);
        nextStreaming[field] = nextLen;
        return { streaming: nextStreaming };
      });
      if (nextLen >= text.length) {
        if (self._streamingInterval) {
          clearInterval(self._streamingInterval);
          self._streamingInterval = null;
        }
        onDone();
      }
    }, intervalMs);
  }

  _startStreamingForMensaje(mensajeIdx, mensaje) {
    var self = this;
    this._cancelStreaming();

    // No animar si el componente nunca se montó (caso típico en unit tests
    // que instancian la clase con `new` y no llaman a componentDidMount).
    if (!this._isMounted) return;
    // Si el mensaje viene en error, no animamos: que se muestre tal cual.
    if (mensaje && mensaje.error) return;

    this.setState({
      streaming: {
        active: true,
        phase: 'explicacion',
        mensajeIdx: mensajeIdx,
        textLen: 0,
      },
    });

    var explicacion = (mensaje && mensaje.respuesta) ? mensaje.respuesta : '';

    function entrarEnLoading() {
      self._setStreamingPhase('loading');
      self._streamingTimeout = setTimeout(entrarEnTabla, STREAM_DELAY_LOADING_MS);
    }

    function entrarEnTabla() {
      self._setStreamingPhase('tabla');
      self._streamingTimeout = setTimeout(function() {
        self._finalizarStreaming();
      }, STREAM_DELAY_TABLA_MS);
    }

    // Flujo: explicación tipeada → loading → tabla aparece → done.
    this._tickTexto(explicacion, STREAM_CHAR_MS_EXPLICACION, 'textLen', entrarEnLoading);
  }

  renderTabla(columnas, filas) {
    if (!columnas || columnas.length === 0) {
      return null;
    }

    // Precomputar el tipo de cada columna recorriendo todos sus valores.
    // Una sola pasada por respuesta (las tablas tienen ≤1000 filas por LIMIT del backend).
    var safeFilas = filas || [];
    var tiposPorColumna = columnas.map(function(col) {
      var valoresCol = safeFilas.map(function(fila) { return fila[col]; });
      return detectColumnType(col, valoresCol);
    });

    return (
      <div className="eric-tabla-wrapper mt-2">
        <table className="table table-sm eric-tabla">
          <thead>
            <tr>
              {columnas.map(function(col, i) {
                var alignClass = tiposPorColumna[i].align === 'right' ? 'text-right' : 'text-left';
                return (
                  <th key={i} className={alignClass} style={{ whiteSpace: 'nowrap' }}>
                    {formatHeader(col)}
                  </th>
                );
              })}
            </tr>
          </thead>
          <tbody>
            {safeFilas.length > 0 ? (
              safeFilas.map(function(fila, i) {
                return (
                  <tr key={i}>
                    {columnas.map(function(col, j) {
                      var tipo = tiposPorColumna[j];
                      var alignClass = tipo.align === 'right' ? 'text-right' : 'text-left';
                      return (
                        <td key={j} className={alignClass}>
                          {formatByType(fila[col], tipo)}
                        </td>
                      );
                    })}
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan={columnas.length} className="text-center text-muted">
                  <FormattedMessage id="eric.sin_filas" defaultMessage="Sin resultados" />
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    );
  }

  renderBurbujaSistema(contenido) {
    return (
      <div className="eric-mensaje eric-mensaje-asistente">
        <div className="eric-burbuja eric-burbuja-asistente eric-burbuja-sistema">
          <div
            className="eric-sistema-encabezado"
            style={{
              fontSize: '11px',
              fontWeight: 600,
              color: '#5a5a5a',
              textTransform: 'uppercase',
              letterSpacing: '0.5px',
              marginBottom: '4px',
            }}
          >
            <i className="fa fa-comments-o mr-1"></i> {this.props.intl.formatMessage({ id: 'eric.nombre_producto', defaultMessage: 'ERIC Analyst' })}
          </div>
          {contenido}
        </div>
      </div>
    );
  }

  renderPantallaInicio() {
    var persona = JSON.parse(localStorage.getItem('persona')) || {};
    var nombreRaw = persona.nombre || '';
    var nombre = nombreRaw.replace(/\w+/g, function(w) { return w.charAt(0).toUpperCase() + w.slice(1).toLowerCase(); });
    var hora = new Date().getHours();
    var saludoId, saludoDefault;
    if (hora >= 5 && hora < 12) {
      saludoId = 'eric.saludo_dias';
      saludoDefault = 'Buenos días';
    } else if (hora >= 12 && hora < 20) {
      saludoId = 'eric.saludo_tardes';
      saludoDefault = 'Buenas tardes';
    } else {
      saludoId = 'eric.saludo_noches';
      saludoDefault = 'Buenas noches';
    }
    var saludo = this.props.intl.formatMessage({ id: saludoId, defaultMessage: saludoDefault });
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '16px', padding: '24px 16px 16px' }}>
        <img
          src="/assets/eric-icon.png"
          alt="ERIC"
          style={{ width: 72, height: 72, objectFit: 'contain', flexShrink: 0 }}
        />
        <h2 style={{ fontSize: '2.5rem', fontWeight: 300, color: '#2d2d2d', margin: 0 }}>
          {saludo}{nombre ? ', ' + nombre : ''}
        </h2>
      </div>
    );
  }

  renderBurbujaPresentacion() {
    return this.renderBurbujaSistema(
      <p className="mb-0" style={{ whiteSpace: 'pre-wrap' }}>
        <FormattedMessage
          id="eric.presentacion"
          defaultMessage="¡Hola! Soy ERIC Analyst y te puedo ayudar a explorar la información de tu flota — móviles, viajes, combustibles, mantenimientos y más — en lenguaje natural. ¿Tenés alguna pregunta sobre tu data?"
        />
      </p>,
    );
  }

  renderFechaMensaje(fechaEnvio, index) {
    if (!fechaEnvio) return null;
    var absoluta = LocaleFormat.formatDateTime(fechaEnvio);
    if (!absoluta) return null;
    var relativa = LocaleFormat.formatFromNow(fechaEnvio);
    var esRelativa = !!(this.state.fechaRelativaIndices && this.state.fechaRelativaIndices[index]);
    // Si no se pudo calcular el relativo, mostrar siempre el absoluto sin toggle.
    var mostrarRelativa = esRelativa && !!relativa;
    var self = this;
    return (
      <span
        className="eric-fecha-mensaje"
        role="button"
        tabIndex={0}
        title={mostrarRelativa ? absoluta : relativa}
        style={{
          fontSize: '11px',
          color: '#999',
          marginLeft: '8px',
          lineHeight: 1,
          alignSelf: 'center',
          cursor: 'pointer',
        }}
        onClick={function() { self._toggleFechaRelativa(index); }}
        onKeyDown={function(e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            self._toggleFechaRelativa(index);
          }
        }}
      >
        {mostrarRelativa ? relativa : absoluta}
      </span>
    );
  }

  // Alterna entre fecha absoluta ("12/06/2026 14:48") y relativa ("hace 5 días")
  // para el mensaje en `index`.
  _toggleFechaRelativa(index) {
    this.setState(function(prev) {
      var actual = prev.fechaRelativaIndices || {};
      var siguiente = Object.assign({}, actual);
      if (siguiente[index]) {
        delete siguiente[index];
      } else {
        siguiente[index] = true;
      }
      return { fechaRelativaIndices: siguiente };
    });
  }

  // Cola de la conversación: durante el streaming muestra el loader breve
  // entre el final del tipeo de la explicación y la aparición de la tabla.
  // Una vez finalizado el streaming no agrega nada al final.
  renderColaConversacion(lastIdx) {
    var streaming = this.state.streaming;
    if (streaming.active && streaming.mensajeIdx === lastIdx) {
      if (streaming.phase === 'loading') {
        return (
          <div className="eric-mensaje eric-mensaje-asistente">
            <VECLoader size={52} variant="breathing" />
          </div>
        );
      }
    }
    return null;
  }

  renderMensaje(mensaje, index) {
    var streaming = this.state.streaming;
    var isStreamingMsg = streaming.active && streaming.mensajeIdx === index;
    var streamingPhase = isStreamingMsg ? streaming.phase : null;
    var respuestaMostrada = mensaje.respuesta;
    if (isStreamingMsg && streamingPhase === 'explicacion' && mensaje.respuesta) {
      respuestaMostrada = mensaje.respuesta.substring(0, streaming.textLen);
    }
    // Tabla / mapa / total_filas aparecen recién a partir de la fase 'tabla'
    // (después del loader). Quedan ocultos en fases 'explicacion' y 'loading'.
    var mostrarVisualizacion = !isStreamingMsg
      || (streamingPhase !== 'explicacion' && streamingPhase !== 'loading');
    var mostrarAcciones = !isStreamingMsg;
    // El bloque de respuesta sólo se renderiza cuando ya hay algo que mostrar:
    // texto de respuesta, tabla, error o advertencia. Mientras el turno está
    // pendiente (esperando al backend), la cola con el loader se renderiza aparte.
    // Sin `advertencia`, el caso sentinel `sin_datos` con explicacion=null
    // resulta en bubble vacío y la UI no muestra nada.
    var tieneAlgoQueMostrar = !!(
      mensaje.respuesta || tieneTabla(mensaje) || mensaje.error || mensaje.advertencia
    );

    // El ref de la pregunta se attachea solo al último turno: es el ancla de
    // scroll cuando el usuario envía una consulta nueva.
    var esUltimo = index === this.state.mensajes.length - 1;

    return (
      <React.Fragment key={index}>
        {mensaje.pregunta && (
          <div
            className="eric-mensaje eric-mensaje-usuario"
            ref={esUltimo ? this._preguntaActualRef : null}
          >
            <div className="eric-burbuja eric-burbuja-usuario">
              <span>{mensaje.pregunta}</span>
            </div>
          </div>
        )}
        {tieneAlgoQueMostrar && (
          <div className="eric-mensaje eric-mensaje-asistente">
            <div className="eric-burbuja eric-burbuja-asistente">
              {mensaje.error ? (
                <div className="alert alert-danger mb-0 p-2" role="alert">
                  <i className="fa fa-exclamation-triangle mr-1"></i>
                  {mensaje.error}
                </div>
              ) : (
                <div>
                  {respuestaMostrada && (
                    isStreamingMsg && streamingPhase === 'explicacion' ? (
                      // Durante el efecto streaming mostramos texto plano con
                      // pre-wrap para que el cursor parpadeante quede inline con
                      // el último carácter tipeado. Si rendereamos markdown sobre
                      // un substring parcial, los pares no cerrados (`**` sin su
                      // contraparte) hacen saltar el layout entre frames.
                      <p className="mb-1" style={{ whiteSpace: 'pre-wrap' }}>
                        {respuestaMostrada}
                        <span className="eric-cursor-tipeo" aria-hidden="true">▌</span>
                      </p>
                    ) : (
                      <div className="mb-1 eric-respuesta-markdown">
                        <ReactMarkdown>{respuestaMostrada}</ReactMarkdown>
                      </div>
                    )
                  )}
                  {mensaje.advertencia && mostrarVisualizacion && (
                    <div className="text-muted small mt-1 eric-advertencia-disclaimer" role="note">
                      <i className="fa fa-exclamation-circle mr-1"></i>
                      {mensaje.advertencia}
                    </div>
                  )}
                  {mostrarVisualizacion && mensaje.chartSpec && (
                    <EricChart
                      ref={(function(self, idx) {
                        return function(c) { self._chartRefs[idx] = c; };
                      })(this, index)}
                      chartSpec={mensaje.chartSpec}
                      filas={mensaje.filas}
                      columnas={mensaje.columnas}
                      fechaDato={mensaje.fechaEnvio}
                      intl={this.props.intl}
                      mapaId={'eric-mapa-' + index}
                    />
                  )}
                  {mostrarVisualizacion && tieneTabla(mensaje) && (
                    <React.Fragment>
                      <div className="eric-tabla-container">
                        {this.renderTabla(mensaje.columnas, mensaje.filas)}
                        <button
                          type="button"
                          className={'eric-tabla-btn-copiar'
                            + (this.state.copiadoTablaEnIndex === index ? ' eric-tabla-btn-copiar-confirmado' : '')}
                          onClick={(function(self, idx, msj) {
                            return function() { self.handleCopiarTabla(idx, msj); };
                          })(this, index, mensaje)}
                          title={this.props.intl.formatMessage({ id: 'eric.copiar_tabla', defaultMessage: 'Copiar tabla' })}
                          aria-label={this.props.intl.formatMessage({ id: 'eric.copiar_tabla', defaultMessage: 'Copiar tabla' })}
                        >
                          <i className={'fa ' + (this.state.copiadoTablaEnIndex === index ? 'fa-check' : 'fa-copy')}></i>
                        </button>
                      </div>
                    </React.Fragment>
                  )}
                  {mostrarVisualizacion
                    && ((tieneTabla(mensaje) && mensaje.totalFilas > 0) || mensaje.metodologia) && (
                    <div style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      gap: '12px',
                      marginTop: '8px',
                    }}>
                      {tieneTabla(mensaje) && mensaje.totalFilas > 0 ? (
                        <small className="text-muted">
                          <FormattedMessage
                            id="eric.total_filas"
                            defaultMessage="{total} {total, plural, one {fila} other {filas}}"
                            values={{ total: mensaje.totalFilas }}
                          />
                        </small>
                      ) : (
                        <span></span>
                      )}
                      {mensaje.metodologia && (
                      <span
                        className="eric-metodologia"
                        style={{ position: 'relative', display: 'inline-flex' }}
                        onMouseEnter={(function(self, idx) {
                          return function() { self.setState({ metodologiaTooltipIndex: idx }); };
                        })(this, index)}
                        onMouseLeave={(function(self) {
                          return function() { self.setState({ metodologiaTooltipIndex: null }); };
                        })(this)}
                      >
                        <span
                          style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '5px',
                            color: '#2b6ca3',
                            fontSize: '0.8rem',
                            cursor: 'help',
                            borderBottom: '1px dotted #2b6ca3',
                          }}
                        >
                          <i className="fa fa-calculator" aria-hidden="true"></i>
                          <FormattedMessage id="eric.metodologia_titulo" defaultMessage="Cómo se calculó" />
                        </span>
                        {this.state.metodologiaTooltipIndex === index && (
                          <span
                            role="tooltip"
                            style={{
                              position: 'absolute',
                              bottom: 'calc(100% + 6px)',
                              right: 0,
                              zIndex: 20,
                              width: '280px',
                              maxWidth: '80vw',
                              padding: '8px 10px',
                              borderRadius: '8px',
                              background: '#0e1c2b',
                              color: '#dbe6f0',
                              fontSize: '0.78rem',
                              lineHeight: '1.45',
                              textAlign: 'left',
                              whiteSpace: 'normal',
                              boxShadow: '0 8px 24px rgba(0,0,0,0.35)',
                            }}
                          >
                            {mensaje.metodologia}
                          </span>
                        )}
                      </span>
                      )}
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        )}
        {mostrarAcciones && !mensaje.error && (mensaje.respuesta || tieneTabla(mensaje)) && (
          <div className="eric-acciones-mensaje">
            {mensaje.id && (
              <React.Fragment>
                <button
                  type="button"
                  className={'eric-btn-accion'
                    + (mensaje.opinion === 'thumbs_up' ? ' eric-btn-accion-thumb-up-activo' : '')}
                  onClick={(function(self, idx, msj) {
                    return function() { self.handleEnviarFeedback(idx, msj, 'thumbs_up'); };
                  })(this, index, mensaje)}
                  title={this.props.intl.formatMessage({
                    id: 'eric.feedback_util',
                    defaultMessage: 'Buena respuesta',
                  })}
                  aria-label={this.props.intl.formatMessage({
                    id: 'eric.feedback_util',
                    defaultMessage: 'Buena respuesta',
                  })}
                  aria-pressed={mensaje.opinion === 'thumbs_up'}
                >
                  <i className={'fa ' + (mensaje.opinion === 'thumbs_up' ? 'fa-thumbs-up' : 'fa-thumbs-o-up')}></i>
                </button>
                <button
                  type="button"
                  className={'eric-btn-accion'
                    + (mensaje.opinion === 'thumbs_down' ? ' eric-btn-accion-thumb-down-activo' : '')}
                  onClick={(function(self, idx, msj) {
                    return function() { self.handleEnviarFeedback(idx, msj, 'thumbs_down'); };
                  })(this, index, mensaje)}
                  title={this.props.intl.formatMessage({
                    id: 'eric.feedback_no_util',
                    defaultMessage: 'Mala respuesta',
                  })}
                  aria-label={this.props.intl.formatMessage({
                    id: 'eric.feedback_no_util',
                    defaultMessage: 'Mala respuesta',
                  })}
                  aria-pressed={mensaje.opinion === 'thumbs_down'}
                >
                  <i className={'fa ' + (mensaje.opinion === 'thumbs_down' ? 'fa-thumbs-down' : 'fa-thumbs-o-down')}></i>
                </button>
              </React.Fragment>
            )}
            <button
              type="button"
              className={'eric-btn-accion'
                + (this.state.copiadoEnIndex === index ? ' eric-btn-accion-confirmado' : '')}
              onClick={(function(self, idx, msj) {
                return function() { self.handleCopiarMensaje(idx, msj); };
              })(this, index, mensaje)}
              title={this.props.intl.formatMessage({
                id: 'eric.copiar_respuesta',
                defaultMessage: 'Copiar respuesta',
              })}
              aria-label={this.props.intl.formatMessage({
                id: 'eric.copiar_respuesta',
                defaultMessage: 'Copiar respuesta',
              })}
            >
              <i className={'fa ' + (this.state.copiadoEnIndex === index ? 'fa-check' : 'fa-copy')}></i>
              {this.state.copiadoEnIndex === index && (
                <span className="eric-btn-accion-flash">
                  <FormattedMessage id="eric.respuesta_copiada" defaultMessage="Copiado" />
                </span>
              )}
            </button>
            {mensaje.chartSpec && mensaje.chartSpec.tipo !== 'mapa_calor' && (
              <button
                type="button"
                className="eric-btn-accion"
                onClick={(function(self, idx) {
                  return function() {
                    var ref = self._chartRefs[idx];
                    if (ref && typeof ref.descargarPng === 'function') ref.descargarPng();
                  };
                })(this, index)}
                title={this.props.intl.formatMessage({ id: 'eric.chart.descargar_grafico_png', defaultMessage: 'Descargar gráfico (PNG)' })}
                aria-label={this.props.intl.formatMessage({ id: 'eric.chart.descargar_grafico_png', defaultMessage: 'Descargar gráfico (PNG)' })}
              >
                <i className="fa fa-image" aria-hidden="true"></i>
              </button>
            )}
            {tieneTabla(mensaje) && (
              <React.Fragment>
                <button
                  type="button"
                  className="eric-btn-accion"
                  onClick={(function(idx, msj) {
                    return function() {
                      descargarCSV(msj.columnas, msj.filas, nombreArchivoDesdeTitulo(msj.chartSpec && msj.chartSpec.titulo, 'datos_eric'));
                    };
                  })(index, mensaje)}
                  title={this.props.intl.formatMessage({ id: 'eric.chart.descargar_tabla_csv', defaultMessage: 'Descargar tabla (CSV)' })}
                  aria-label={this.props.intl.formatMessage({ id: 'eric.chart.descargar_tabla_csv', defaultMessage: 'Descargar tabla (CSV)' })}
                >
                  <i className="fa fa-file-text-o" aria-hidden="true"></i>
                </button>
                <button
                  type="button"
                  className="eric-btn-accion"
                  onClick={(function(idx, msj) {
                    return function() {
                      descargarXLSX(msj.columnas, msj.filas, nombreArchivoDesdeTitulo(msj.chartSpec && msj.chartSpec.titulo, 'datos_eric'));
                    };
                  })(index, mensaje)}
                  title={this.props.intl.formatMessage({ id: 'eric.chart.descargar_tabla_excel', defaultMessage: 'Descargar tabla (Excel)' })}
                  aria-label={this.props.intl.formatMessage({ id: 'eric.chart.descargar_tabla_excel', defaultMessage: 'Descargar tabla (Excel)' })}
                >
                  <i className="fa fa-file-excel-o" aria-hidden="true"></i>
                </button>
              </React.Fragment>
            )}
            {this.renderFechaMensaje(mensaje.fechaEnvio, index)}
          </div>
        )}
      </React.Fragment>
    );
  }

  renderModalFeedbackNegativo() {
    var fm = this.state.feedbackModal;
    if (!fm.open) return null;
    var self = this;

    var CATEGORIAS = [
      { value: 'datos_incorrectos',   label: this.props.intl.formatMessage({ id: 'eric.feedback_negativo_categoria.datos_incorrectos',  defaultMessage: 'Datos incorrectos' }) },
      { value: 'no_entendio',        label: this.props.intl.formatMessage({ id: 'eric.feedback_negativo_categoria.no_entendio',         defaultMessage: 'No entendió la pregunta' }) },
      { value: 'respuesta_parcial',  label: this.props.intl.formatMessage({ id: 'eric.feedback_negativo_categoria.respuesta_parcial',   defaultMessage: 'Respuesta incompleta' }) },
      { value: 'tabla_vacia',        label: this.props.intl.formatMessage({ id: 'eric.feedback_negativo_categoria.tabla_vacia',         defaultMessage: 'La tabla vino vacía siendo que hay datos' }) },
      { value: 'otro',               label: this.props.intl.formatMessage({ id: 'eric.feedback_negativo_categoria.otro',                defaultMessage: 'Otro' }) },
    ];

    return (
      <div
        style={{
          position: 'fixed', inset: 0, zIndex: 9999,
          background: 'rgba(0,0,0,0.45)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
        }}
        onClick={function(e) { if (e.target === e.currentTarget) self.handleCerrarModalFeedback(); }}
      >
        <div style={{
          background: '#fff', borderRadius: '12px', padding: '28px 32px',
          width: '100%', maxWidth: '460px', boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
        }}>
          <h5 style={{ margin: '0 0 16px', fontWeight: 600, fontSize: '17px', color: '#111' }}>
            <FormattedMessage id="eric.feedback_negativo_titulo" defaultMessage="Dar feedback negativo" />
          </h5>

          <label style={{ display: 'block', fontSize: '13px', color: '#444', marginBottom: '6px' }}>
            <FormattedMessage id="eric.feedback_negativo_categoria_label" defaultMessage="¿Qué tipo de problema querés reportar? (opcional)" />
          </label>
          <select
            className="form-control form-control-sm"
            style={{ marginBottom: '16px' }}
            value={fm.categoria}
            onChange={function(e) {
              var val = e.target.value;
              self.setState(function(prev) {
                return { feedbackModal: Object.assign({}, prev.feedbackModal, { categoria: val }) };
              });
            }}
          >
            <option value="">{this.props.intl.formatMessage({ id: 'eric.feedback_negativo_categoria.placeholder', defaultMessage: 'Seleccioná una categoría...' })}</option>
            {CATEGORIAS.map(function(c) {
              return <option key={c.value} value={c.value}>{c.label}</option>;
            })}
          </select>

          <label style={{ display: 'block', fontSize: '13px', color: '#444', marginBottom: '6px' }}>
            <FormattedMessage id="eric.feedback_negativo_comentario_label" defaultMessage="Comentarios adicionales (opcional)" />
          </label>
          <textarea
            className="form-control form-control-sm"
            rows={4}
            style={{ resize: 'vertical', marginBottom: '20px' }}
            placeholder={this.props.intl.formatMessage({
              id: 'eric.feedback_negativo_placeholder',
              defaultMessage: '¿Qué fue lo que no te satisfizo de esta respuesta?',
            })}
            value={fm.comentario}
            onChange={function(e) {
              var val = e.target.value;
              self.setState(function(prev) {
                return { feedbackModal: Object.assign({}, prev.feedbackModal, { comentario: val }) };
              });
            }}
          />

          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
            <button
              type="button"
              className="btn btn-sm btn-default"
              onClick={this.handleCerrarModalFeedback}
              style={{ minWidth: '80px' }}
            >
              <FormattedMessage id="eric.feedback_negativo_cancelar" defaultMessage="Cancelar" />
            </button>
            <button
              type="button"
              className="btn btn-sm eric-modal-btn-enviar"
              onClick={this.handleSubmitFeedbackNegativo}
              style={{ minWidth: '80px' }}
            >
              <FormattedMessage id="eric.feedback_negativo_enviar" defaultMessage="Enviar" />
            </button>
          </div>
        </div>
      </div>
    );
  }

  renderSidebar() {
    var self = this;
    var conversaciones = this.state.conversaciones || [];
    var cargandoConversaciones = this.state.cargandoConversaciones;
    var conversacionActiva = this.state.conversacionActiva;
    var paginacion = this.state._conversacionesPaginacion;
    var hayMas = paginacion && paginacion.total > conversaciones.length;

    return (
      <div className="eric-sidebar">
        {/* Header del sidebar */}
        <div className="eric-sidebar-header">
          <div className="eric-sidebar-header-top">
            <span className="eric-sidebar-titulo">
              <FormattedMessage id="eric.sidebar.titulo" defaultMessage="Conversaciones" />
            </span>
            <div style={{ display: 'flex', alignItems: 'center', gap: '2px' }}>
              <div style={{ position: 'relative' }}>
                <button
                  type="button"
                  className="eric-sidebar-btn-menu"
                  title={this.props.intl.formatMessage({ id: 'eric.sidebar.opciones', defaultMessage: 'Opciones' })}
                  onClick={function(e) {
                    e.stopPropagation();
                    self.setState(function(s) { return { menuHeaderAbierto: !s.menuHeaderAbierto }; });
                  }}
                >
                  <i className="fa fa-ellipsis-v"></i>
                </button>
                {this.state.menuHeaderAbierto && (
                  <div>
                    <div
                      style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 198 }}
                      onClick={function() { self.setState({ menuHeaderAbierto: false }); }}
                    />
                  <div className="eric-sidebar-dropdown">
                    <button
                      type="button"
                      className="eric-sidebar-dropdown-item eric-sidebar-dropdown-item-danger"
                      onClick={this.handleBorrarTodas}
                    >
                      <i className="fa fa-trash-o" style={{ marginRight: '7px' }}></i>
                      <FormattedMessage id="eric.sidebar.borrar_todas" defaultMessage="Borrar todas las conversaciones" />
                    </button>
                  </div>
                  </div>
                )}
              </div>
              <button
                type="button"
                className="eric-sidebar-btn-colapsar"
                onClick={this.handleToggleSidebar}
                title={this.props.intl.formatMessage({ id: 'eric.sidebar.colapsar', defaultMessage: 'Colapsar' })}
              >
                <i className="fa fa-chevron-right" style={{ fontSize: '13px' }}></i>
              </button>
            </div>
          </div>
          <button
            type="button"
            className="eric-sidebar-btn-nueva"
            onClick={this.handleNuevaConversacion}
            title={this.props.intl.formatMessage({ id: 'eric.sidebar.nueva', defaultMessage: 'Nueva conversación' })}
          >
            <i className="fa fa-plus mr-1"></i>
            <FormattedMessage id="eric.sidebar.nueva" defaultMessage="Nueva conversación" />
          </button>
        </div>

        {/* Body del sidebar */}
        <div className="eric-sidebar-body" onScroll={this.handleSidebarScroll} ref={this._sidebarBodyRef}>
          {cargandoConversaciones && conversaciones.length === 0 ? (
            <p className="eric-sidebar-estado">
              <FormattedMessage id="eric.sidebar.cargando" defaultMessage="Cargando conversaciones…" />
            </p>
          ) : conversaciones.length === 0 ? (
            <p className="eric-sidebar-estado">
              <FormattedMessage
                id="eric.sidebar.sin_conversaciones"
                defaultMessage="Todavía no tenés conversaciones. Empezá una nueva."
              />
            </p>
          ) : (
            conversaciones.map(function(conv) {
              var esActiva = conv.id === conversacionActiva;
              return (
                <div
                  key={conv.id}
                  className={'eric-sidebar-item' + (esActiva ? ' eric-sidebar-item-activo' : '')}
                  onClick={(function(id) {
                    return function() { self.handleAbrirConversacion(id); };
                  })(conv.id)}
                >
                  <div className="eric-sidebar-item-titulo" title={conv.titulo}>
                    {conv.titulo}
                  </div>
                  <button
                    type="button"
                    className="eric-sidebar-btn-borrar"
                    onClick={(function(id) {
                      return function(e) {
                        e.stopPropagation();
                        self.handleEliminarConversacion(id);
                      };
                    })(conv.id)}
                    title={self.props.intl.formatMessage({
                      id: 'eric.confirmar_eliminar_titulo',
                      defaultMessage: 'Eliminar conversación',
                    })}
                    aria-label={self.props.intl.formatMessage({
                      id: 'eric.confirmar_eliminar_titulo',
                      defaultMessage: 'Eliminar conversación',
                    })}
                  >
                    <i className="fa fa-trash-o"></i>
                  </button>
                </div>
              );
            })
          )}
        </div>

        {/* Spinner de carga al hacer scroll infinito */}
        {cargandoConversaciones && conversaciones.length > 0 && (
          <div style={{ textAlign: 'center', padding: '8px 0', color: '#aaa', fontSize: '12px' }}>
            <i className="fa fa-spinner fa-spin"></i>
          </div>
        )}
      </div>
    );
  }

  render() {
    if (this.state.redirectTo) {
      return <Redirect push to={this.state.redirectTo} />;
    }

    var mensajes = this.state.mensajes;
    var cargandoApi = this.state.cargando;
    var streamingActive = this.state.streaming.active;
    var locale = (this.props.intl && this.props.intl.locale) || 'es';
    var frasesLocale = locale.startsWith('pt') ? 'pt' : 'es';
    var frases = FRASES_LOADING[frasesLocale];
    var fraseActual = frases[this.state.fraseLoadingIdx % frases.length];
    // 'cargando' representa "no permitir interacción" (input deshabilitado,
    // botón de enviar bloqueado): se aplica tanto al fetch en curso como
    // al efecto streaming posterior, así no se puede submitear mientras
    // todavía se está animando la respuesta anterior.
    var cargando = cargandoApi || streamingActive;
    var cargandoConversacion = this.state.cargandoConversacion;
    var conversacionActiva = this.state.conversacionActiva;
    var tieneTexto = this.state.tieneTexto;
    var sugerencias = this.state.sugerencias;
    var self = this;
    var sidebarAbierto = this.state.sidebarAbierto;

    // Solo mostrar pantalla de inicio cuando NO hay conversación activa ni cargando
    var esInicio = mensajes.length === 0 && !cargando && !cargandoConversacion && conversacionActiva === null;

    return (
      <div className="eric-layout-root">
        {/* Panel principal del chat */}
        <div className={'eric-chat-panel' + (sidebarAbierto ? ' eric-chat-panel-con-sidebar' : '')}>
          {/* Botón para abrir sidebar cuando está colapsado */}
          {!sidebarAbierto && (
            <button
              type="button"
              onClick={this.handleToggleSidebar}
              title={this.props.intl.formatMessage({ id: 'eric.sidebar.titulo', defaultMessage: 'Conversaciones' })}
              style={{ position: 'absolute', top: '12px', right: '12px', background: 'none', border: 'none', cursor: 'pointer', color: '#9ca3af', padding: '4px', borderRadius: '6px', zIndex: 10, lineHeight: 1 }}
            >
              <i className="fa fa-comments-o" style={{ fontSize: '1.4rem' }}></i>
            </button>
          )}
          <div style={{ width: '70%', minWidth: '320px', margin: '0 auto', flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden', minHeight: 0 }}>
            {esInicio ? (
              /* Estado inicial: solo input centrado verticalmente */
              <div style={{ minHeight: '65vh', display: 'flex', flexDirection: 'column', justifyContent: 'center', gap: '16px' }}>
                {this.renderPantallaInicio()}
                <div style={{ border: '1px solid #d5d5d5', borderRadius: '20px', boxShadow: '0 2px 10px rgba(0,0,0,0.08)', background: '#fff', padding: '16px 20px 12px' }}>
                  <textarea
                    className="form-control eric-textarea-inicio"
                    style={{ resize: 'none', width: '100%', height: '80px', border: 'none', boxShadow: 'none', outline: 'none', padding: 0, background: 'transparent', fontSize: '16px' }}
                    ref={this._consultaRef}
                    defaultValue=""
                    onKeyDown={this.handleKeyDown}
                    onChange={this.handleTextareaChange}
                    placeholder={this.props.intl.formatMessage({ id: 'eric.placeholder_inicio', defaultMessage: '¡Hola! Soy ERIC, ¿cómo te puedo ayudar?' })}
                    disabled={cargandoApi}
                  />
                  <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '8px', minHeight: '40px' }}>
                    {(tieneTexto || cargandoApi) && (
                      <button className="eric-btn-enviar" onClick={this.handleSubmit} disabled={cargandoApi}>
                        {cargandoApi ? <i className="fa fa-spinner fa-spin"></i> : <i className="fa fa-arrow-up"></i>}
                      </button>
                    )}
                  </div>
                </div>
                {/* Las sugerencias son todas preguntas sobre datos del tenant
                    (modo analyst). Si el usuario no tiene ERIC_ANALYST_CONSULTAR
                    no podría ejecutarlas — las ocultamos para no ofrecer
                    chips que después responderían 403. */}
                {Security.hasPermission('ERIC_ANALYST_CONSULTAR') && (
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginTop: '4px' }}>
                    {sugerencias.map(function(s, i) {
                      return (
                        <button key={i} className="eric-chip-sugerencia" onClick={function() { self.handleSugerencia(s); }} disabled={cargandoApi}>
                          {s}
                        </button>
                      );
                    })}
                  </div>
                )}
              </div>
            ) : (
              /* Con mensajes: estilo Claude, sin card */
              <div style={{ display: 'flex', flexDirection: 'column', flex: 1, overflow: 'hidden', minHeight: 0 }}>
                {/* Conversación */}
                <div ref={this._conversacionRef} className="eric-conversacion" style={{ padding: '8px 0', display: 'flex', flexDirection: 'column', gap: '20px', flex: 1, overflowY: 'auto', minHeight: 0 }}>
                  {mensajes.map(function(mensaje, i) { return this.renderMensaje(mensaje, i); }.bind(this))}
                  {cargandoApi && (
                    <div className="eric-mensaje eric-mensaje-asistente">
                      <div className="eric-loading-frase-wrapper">
                        <VECLoader size={32} variant="breathing" />
                        <span key={this.state.fraseLoadingIdx} className="eric-loading-frase">
                          {fraseActual}
                        </span>
                      </div>
                    </div>
                  )}
                  {!cargandoApi && mensajes.length > 0 && this.renderColaConversacion(mensajes.length - 1)}
                  <div ref={this._mensajesEndRef} />
                </div>

                {/* Input abajo */}
                <div style={{ paddingTop: '16px', flexShrink: 0 }}>
                  {this.state.conversacionCerrada ? (
                    <div style={{ border: '1px solid #e9d5ff', borderRadius: '20px', background: '#faf5ff', padding: '16px 20px', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px', textAlign: 'center' }}>
                      <span style={{ fontSize: '13px', color: '#6b21a8' }}>
                        <FormattedMessage
                          id="eric.conversacion_cerrada_aviso"
                          defaultMessage="Conversación cerrada — se creó un ticket de soporte"
                        />
                      </span>
                      <button
                        className="eric-btn-nueva-conversacion"
                        style={{ background: '#7c3aed', color: '#fff', border: 'none', borderRadius: '12px', padding: '8px 20px', fontSize: '13px', fontWeight: 600, cursor: 'pointer' }}
                        onClick={this.handleNuevaConversacion}
                      >
                        <FormattedMessage
                          id="eric.iniciar_nueva_conversacion"
                          defaultMessage="Iniciar nueva conversación"
                        />
                      </button>
                    </div>
                  ) : (
                    <div style={{ border: '1px solid #d5d5d5', borderRadius: '20px', boxShadow: '0 2px 10px rgba(0,0,0,0.08)', background: '#fff', padding: '12px 16px 10px' }}>
                      <textarea
                        className="form-control"
                        style={{ resize: 'none', width: '100%', height: '60px', border: 'none', boxShadow: 'none', outline: 'none', padding: 0, background: 'transparent' }}
                        ref={this._consultaRef}
                        defaultValue=""
                        onKeyDown={this.handleKeyDown}
                        onChange={this.handleTextareaChange}
                        placeholder={this.props.intl.formatMessage({ id: 'eric.consulta_placeholder', defaultMessage: 'Escribí tu consulta... (Enter para enviar, Shift+Enter para nueva línea)' })}
                        disabled={cargandoApi}
                      />
                      <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '6px', minHeight: '36px' }}>
                        {(tieneTexto || cargandoApi) && (
                          <button className="eric-btn-enviar" onClick={this.handleSubmit} disabled={cargandoApi}>
                            {cargandoApi ? <i className="fa fa-spinner fa-spin"></i> : <i className="fa fa-arrow-up"></i>}
                          </button>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}
            <p className="eric-disclaimer">
              <FormattedMessage
                id="eric.disclaimer"
                defaultMessage="ERIC puede cometer errores. Verificá la información antes de tomar decisiones."
              />
            </p>
          </div>
        </div>

        {/* Sidebar de conversaciones — derecha */}
        <div className={'eric-sidebar-wrapper' + (sidebarAbierto ? ' eric-sidebar-wrapper-abierto' : '')}>
          {this.renderSidebar()}
        </div>

        {/* Botón toggle sidebar — visible en pantallas < 1200px */}
        <button
          type="button"
          className="eric-sidebar-toggle"
          onClick={this.handleToggleSidebar}
          title={this.props.intl.formatMessage({ id: 'eric.sidebar.titulo', defaultMessage: 'Conversaciones' })}
          aria-label={this.props.intl.formatMessage({ id: 'eric.sidebar.titulo', defaultMessage: 'Conversaciones' })}
        >
          <i className="fa fa-comments-o"></i>
        </button>

        <style>{`
          body.eric-analyst-active footer {
            display: none !important;
          }
          body.eric-analyst-active .app-content.content {
            padding: 0 !important;
            min-height: 0 !important;
            height: calc(100vh - 5rem) !important;
            display: flex !important;
            flex-direction: column !important;
            overflow: visible !important;
          }
          .eric-layout-root {
            display: flex;
            flex: 1;
            min-height: 0;
            overflow: hidden;
          }
          .eric-sidebar-toggle {
            display: none;
            position: fixed;
            top: 12px;
            right: 12px;
            z-index: 200;
            background: #7c3aed;
            color: #fff;
            border: none;
            border-radius: 8px;
            width: 36px;
            height: 36px;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            font-size: 16px;
          }
          @media (max-width: 1200px) {
            .eric-sidebar-toggle { display: flex; }
          }
          .eric-sidebar-wrapper {
            width: 0;
            flex-shrink: 0;
            overflow: hidden;
            transition: width 0.2s ease;
          }
          .eric-sidebar-wrapper-abierto {
            width: 280px;
            min-width: 280px;
            position: sticky;
            top: 0;
            align-self: flex-start;
            height: calc(100vh - 5rem);
            overflow: hidden;
          }
          @media (max-width: 1200px) {
            .eric-sidebar-wrapper-abierto {
              position: fixed;
              top: 0;
              right: 0;
              height: 100%;
              z-index: 150;
              width: 260px;
              min-width: 260px;
            }
          }
          .eric-chat-panel {
            flex: 1;
            min-width: 0;
            padding: 0 16px;
            display: flex;
            flex-direction: column;
            overflow: hidden;
            position: relative;
          }
          .eric-sidebar {
            display: flex;
            flex-direction: column;
            height: 100%;
            background: transparent;
            border-left: 1px solid #e5e7eb;
            width: 280px;
            min-width: 280px;
          }
          .eric-sidebar-header {
            padding: 14px 12px 10px;
            border-bottom: 1px solid #e5e7eb;
            display: flex;
            flex-direction: column;
            gap: 8px;
          }
          .eric-sidebar-titulo {
            font-size: 14px;
            font-weight: 600;
            color: #374151;
          }
          .eric-sidebar-btn-nueva {
            background: #7c3aed;
            color: #fff;
            border: none;
            border-radius: 8px;
            padding: 7px 10px;
            font-size: 14px;
            cursor: pointer;
            text-align: left;
            transition: background 0.15s;
          }
          .eric-sidebar-btn-nueva:hover { background: #6d28d9; }
          .eric-modal-btn-enviar {
            background: #7c3aed;
            border-color: #7c3aed;
            color: #fff;
            transition: background 0.15s, border-color 0.15s;
          }
          .eric-modal-btn-enviar:hover,
          .eric-modal-btn-enviar:focus,
          .eric-modal-btn-enviar:active {
            background: #6d28d9;
            border-color: #6d28d9;
            color: #fff;
            outline: none;
          }
          .eric-sidebar-body {
            flex: 1;
            overflow-y: auto;
            padding: 4px 6px;
          }
          .eric-sidebar-estado {
            font-size: 12px;
            color: #888;
            padding: 12px 8px;
            margin: 0;
          }
          .eric-sidebar-item {
            position: relative;
            padding: 5px 10px;
            border-radius: 6px;
            cursor: pointer;
            margin-bottom: 1px;
            transition: background 0.12s;
          }
          .eric-sidebar-item:hover { background: #f0edfb; }
          .eric-sidebar-item-activo { background: #ede9fe !important; }
          .eric-sidebar-item-titulo {
            font-size: 14px;
            color: #1a1a1a;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            max-width: 200px;
            font-weight: 400;
          }
          .eric-sidebar-item-meta {
            display: flex;
            gap: 8px;
            margin-top: 2px;
          }
          .eric-sidebar-item-msgs {
            font-size: 12px;
            color: #aaa;
          }
          .eric-sidebar-btn-borrar {
            position: absolute;
            top: 50%;
            right: 6px;
            transform: translateY(-50%);
            background: transparent;
            border: none;
            color: #bbb;
            font-size: 14px;
            padding: 4px 6px;
            border-radius: 4px;
            cursor: pointer;
            opacity: 0;
            transition: opacity 0.12s, color 0.12s;
          }
          .eric-sidebar-item:hover .eric-sidebar-btn-borrar { opacity: 1; }
          .eric-sidebar-btn-borrar:hover { color: #dc2626; background: #fef2f2; }
          .eric-sidebar-header-top {
            display: flex;
            align-items: center;
            justify-content: space-between;
          }
          .eric-sidebar-btn-menu {
            background: transparent;
            border: none;
            outline: none;
            color: #9ca3af;
            padding: 4px 7px;
            border-radius: 4px;
            cursor: pointer;
            opacity: 0;
            transition: opacity 0.12s, background 0.12s, color 0.12s;
            font-size: 14px;
            line-height: 1;
          }
          .eric-sidebar-header:hover .eric-sidebar-btn-menu { opacity: 1; }
          .eric-sidebar-btn-menu:hover { background: #f3f4f6; color: #374151; }
          .eric-sidebar-btn-colapsar {
            background: transparent;
            border: none;
            outline: none;
            color: #6b7280;
            padding: 4px 7px;
            border-radius: 4px;
            cursor: pointer;
            font-size: 14px;
            line-height: 1;
            transition: background 0.12s, color 0.12s;
          }
          .eric-sidebar-btn-colapsar:hover { background: #f3f4f6; color: #374151; }
          .eric-sidebar-dropdown {
            position: absolute;
            top: calc(100% + 4px);
            right: 0;
            background: #fff;
            border: 1px solid #e5e7eb;
            border-radius: 8px;
            box-shadow: 0 4px 16px rgba(0,0,0,0.10);
            z-index: 200;
            min-width: 230px;
            padding: 4px 0;
          }
          .eric-sidebar-dropdown-item {
            display: flex;
            align-items: center;
            width: 100%;
            padding: 9px 14px;
            background: transparent;
            border: none;
            font-size: 13px;
            cursor: pointer;
            text-align: left;
            transition: background 0.12s;
            white-space: nowrap;
          }
          .eric-sidebar-dropdown-item:hover { background: #f3f4f6; }
          .eric-sidebar-dropdown-item-danger { color: #dc2626; }
          .eric-sidebar-dropdown-item-danger:hover { background: #fef2f2; }
          .eric-sidebar-footer {
            padding: 8px 12px;
            border-top: 1px solid #e5e7eb;
          }
          .eric-sidebar-btn-mas {
            width: 100%;
            background: transparent;
            border: 1px solid #d1d5db;
            border-radius: 8px;
            padding: 6px 12px;
            font-size: 12px;
            color: #555;
            cursor: pointer;
            transition: background 0.12s;
          }
          .eric-sidebar-btn-mas:hover { background: #f3f4f6; }
          .eric-sidebar-btn-mas:disabled { opacity: 0.5; cursor: default; }
          .eric-mensaje {
            display: flex;
          }
          .eric-mensaje-usuario {
            justify-content: flex-end;
          }
          .eric-mensaje-asistente {
            justify-content: flex-start;
          }
          .eric-burbuja {
            max-width: 80%;
            border-radius: 18px;
            padding: 10px 16px;
            word-break: break-word;
          }
          .eric-burbuja-usuario {
            background-color: #7c3aed;
            color: #fff;
            border-bottom-right-radius: 4px;
          }
          .eric-burbuja-asistente {
            background: none;
            color: #1a1a1a;
            padding: 0;
            max-width: 100%;
            border-radius: 0;
          }
          .eric-cursor-tipeo {
            display: inline-block;
            margin-left: 2px;
            color: #7c3aed;
            font-weight: 400;
            animation: eric-cursor-blink 1s step-end infinite;
          }
          @keyframes eric-cursor-blink {
            0%, 50% { opacity: 1; }
            50.01%, 100% { opacity: 0; }
          }
          .eric-loading-frase-wrapper {
            display: flex;
            align-items: center;
            gap: 10px;
          }
          .eric-loading-frase {
            font-size: 14px;
            background: linear-gradient(90deg, #aaa 0%, #aaa 35%, #e0e0e0 50%, #aaa 65%, #aaa 100%);
            background-size: 300% auto;
            -webkit-background-clip: text;
            background-clip: text;
            -webkit-text-fill-color: transparent;
            animation: eric-frase-fadein 0.5s ease forwards,
                       eric-shimmer 2s linear 0.3s infinite;
          }
          @keyframes eric-frase-fadein {
            from { opacity: 0; transform: translateY(4px); }
            to   { opacity: 1; transform: translateY(0); }
          }
          @keyframes eric-shimmer {
            from { background-position: 100% center; }
            to   { background-position: -100% center; }
          }
          .eric-tabla-container {
            position: relative;
          }
          .eric-tabla-btn-copiar {
            position: absolute;
            top: 14px;
            right: 6px;
            opacity: 0;
            transition: opacity 150ms ease;
            background: rgba(255,255,255,0.92);
            border: 1px solid #e5e7eb;
            border-radius: 5px;
            color: #555;
            font-size: 14px;
            padding: 5px 8px;
            cursor: pointer;
            line-height: 1;
          }
          .eric-tabla-container:hover .eric-tabla-btn-copiar { opacity: 1; }
          .eric-tabla-btn-copiar:hover { background: #f3f4f6; color: #111; }
          .eric-tabla-btn-copiar.eric-tabla-btn-copiar-confirmado { color: #16a34a; opacity: 1; }
          .eric-tabla-wrapper {
            max-height: 60vh;
            overflow: auto;
            border-radius: 6px;
          }
          .eric-tabla {
            width: 100%;
            border-collapse: collapse;
            margin-bottom: 0;
          }
          .eric-tabla thead th {
            font-weight: 600;
            font-size: 13px;
            padding: 8px 12px;
            border-bottom: 2px solid #e5e7eb;
            white-space: nowrap;
            position: sticky;
            top: 0;
            z-index: 1;
            background-color: #fff;
          }
          .eric-tabla td {
            padding: 8px 12px;
            border-top: 1px solid #f0f0f0;
            font-size: 13px;
            white-space: nowrap;
            vertical-align: middle;
          }
          .eric-tabla tbody tr:first-child td { border-top: none; }
          .eric-tabla tbody tr:hover td { background-color: #fafafa; }
          .eric-tabla .text-right {
            text-align: right;
            font-variant-numeric: tabular-nums;
          }
          .eric-acciones-mensaje {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            gap: 2px;
            padding-left: 4px;
            margin-top: 2px;
            margin-bottom: 4px;
          }
          .eric-btn-accion {
            background: transparent;
            border: none;
            color: #888;
            font-size: 16px;
            padding: 6px 8px;
            border-radius: 4px;
            cursor: pointer;
            display: inline-flex;
            align-items: center;
            gap: 6px;
            line-height: 1;
            transition: background-color 120ms ease, color 120ms ease;
          }
          .eric-btn-accion:hover { background-color: #e8eaed; color: #333; }
          .eric-btn-accion:focus { outline: none; background-color: #e8eaed; color: #333; }
          .eric-btn-accion:active { background-color: #d8dade; }
          .eric-btn-accion.eric-btn-accion-confirmado { color: #28a745; }
          .eric-btn-accion.eric-btn-accion-thumb-up-activo { color: #16a34a; background-color: #ecfdf5; }
          .eric-btn-accion.eric-btn-accion-thumb-down-activo { color: #dc2626; background-color: #fef2f2; }
          .eric-btn-accion-flash { font-size: 13px; }
          .eric-mapa-calor-wrapper {
            margin-bottom: 12px;
          }
          .eric-mapa-calor-container {
            width: 100%;
            height: 380px;
            border-radius: 8px;
            z-index: 0;
          }
          .eric-chart-wrapper {
            margin: 8px 0 4px;
          }
          .eric-chart-titulo {
            font-size: 14px;
            font-weight: 600;
            color: #333;
            margin-bottom: 6px;
          }
          .eric-chart-aviso-fecha {
            font-size: 11px;
            color: #aaa;
            margin-top: 4px;
            display: flex;
            align-items: center;
            gap: 4px;
          }
          .eric-chart-descarga {
            display: flex;
            align-items: center;
            gap: 6px;
            margin-top: 8px;
          }
          .eric-chart-descarga-label {
            font-size: 12px;
            color: #888;
          }
          .eric-chart-btn-descarga {
            background: transparent;
            border: 1px solid #d1d5db;
            border-radius: 5px;
            padding: 3px 10px;
            font-size: 12px;
            color: #555;
            cursor: pointer;
            transition: background 0.12s, border-color 0.12s;
          }
          .eric-chart-btn-descarga:hover {
            background: #f3f4f6;
            border-color: #9ca3af;
            color: #111;
          }
          .eric-textarea-inicio::placeholder { color: #666; }
          @keyframes eric-btn-pop {
            from { opacity: 0; transform: scale(0.7); }
            to   { opacity: 1; transform: scale(1);   }
          }
          .eric-btn-enviar {
            width: 38px;
            height: 38px;
            border-radius: 10px;
            border: none;
            background: #7c3aed;
            color: #fff;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            animation: eric-btn-pop 0.18s ease-out;
            font-size: 15px;
            padding: 0;
            flex-shrink: 0;
          }
          .eric-btn-enviar:hover { background: #6d28d9; }
          .eric-btn-enviar:active { background: #5b21b6; }
          .eric-btn-enviar:disabled { background: #c4b5fd; cursor: default; }
          .eric-chip-sugerencia {
            flex: 1 1 calc(50% - 4px);
            background: #fff;
            border: 1px solid #e0e0e0;
            border-radius: 12px;
            padding: 10px 14px;
            text-align: left;
            font-size: 13px;
            color: #444;
            cursor: pointer;
            transition: border-color 0.15s, background 0.15s, color 0.15s;
            line-height: 1.4;
          }
          .eric-chip-sugerencia:hover { border-color: #7c3aed; background: #faf5ff; color: #7c3aed; }
          .eric-chip-sugerencia:disabled { opacity: 0.5; cursor: default; }
          .eric-disclaimer {
            text-align: center;
            font-size: 11px;
            color: #bbb;
            margin-top: 12px;
            margin-bottom: 0;
          }
        `}</style>

        {cargandoApi && <Loading hideSpinner={true} />}
        {this.renderModalFeedbackNegativo()}
      </div>
    );
  }
}

export default withRouter(injectIntl(EricAnalyst));
